import classNames from "classnames";
import _ from "lodash";
import React from "react";
import Dropzone from "react-dropzone";
import Moment from "react-moment";
import { connect } from "react-redux";
import { ToastsStore } from "react-toasts";
import { Button, Col, Input, Label, Row, Table } from "reactstrap";
import XLSX from "xlsx";
import {
  checkAttritionPackages,
  getAttritions,
  getBomDetails,
  getColumnAliases,
  getColumns,
  getSystemSettings,
  insertAttritionList,
  saveCustomer,
  savePartsRevs,
  shareFile,
  updateQuotes,
} from "../../../actions";
import { currencyList } from "../../../constants/currency";
import {
  DIGIKEY_REFRESH_DETAILS_COLUMN,
  DIGIKEY_REFRESH_DETAILS_LABEL,
  LEADLESS_ROW_CLASS,
  OBSOLETE_ROW_CLASS,
  UNMATCHED_EXACT_MATCH_MESSAGE,
  UNMATCHED_RESOLVED_ROW_CLASS,
  UNMATCHED_ROW_CLASS,
  UNMATCHED_VIEW_OPTIONS_LABEL,
  UNMATCHED_VIEW_OPTIONS_LOADING_LABEL,
  UNMATCHED_VIEW_OPTIONS_RETRY_LABEL,
  applySelectedAlternateToLine,
  applySelectedUnmatchedPartToLine,
  buildAlternateFromRefreshPart,
  buildLineAlternateManufacturers,
  buildLineAlternateMpns,
  buildLineAlternateSelections,
  collectObsoleteBomLines,
  collectSelectedUnmatchedNeedingSync,
  collectUnmatchedBomLines,
  collectUniqueQuotedVendors,
  countUniqueQuotedVendors,
  mergeLatestUnmatchedSelections,
  formatUsImportTariff,
  getDigiKeyAlternateSaveFailureMessage,
  getDigiKeyRefreshLineKey,
  getDigiKeyRefreshOriginalPartNumber,
  getDigiKeyRefreshPartNumber,
  getExportManufacturer,
  getLineReviewKey,
  getObsoleteAlternateCount,
  getObsoleteLineKey,
  getObsoleteLinesMissingAlternate,
  getObsoleteRowTooltip,
  getRohsValueFromPartStatusCell,
  getSavedAlternateFromResponse,
  getTableColumnKeys,
  getUnmatchedLinesSkippedForQuote,
  getUnmatchedOriginalMpn,
  getUnmatchedViewOptionsCache,
  hasLineAlternateSelected,
  hasObsoleteAlternateSelected,
  isBomSectionRow,
  isExportManufacturerColumn,
  isLeadlessLine,
  isObsoleteLine,
  isUnmatchedLine,
  lineNeedsDigiKeyDetailsRefresh,
  lineMatchesSelectedAlternateMpn,
  lineHasCachedViewOptions,
  markLineMissingInfoSynced,
  lineUsesAlternateForQuote,
  matchesBomLine,
  organizeBomByMountingType,
  preferAlternateWithEnrichment,
  resolveLineSelectedAlternateRecommendation,
  resolveRohsStatus,
  preserveAlternateLineState,
  suggestedPartHasStock,
  normalizeMountingType,
  categoryTextForMounting,
  resolvePackageValue,
} from "../../../constants/digiKeyColumns";
import { ImportIcon } from "../../../constants/icons";
import { getIssueCountBadge, isIssueRowActionable } from "../../../constants/issueReportUtils";
import {
  applyAttritionQtyColumns,
  attrQtyColumn,
  buildAttritionPackageMap,
  buildInitialQuoteRefState,
  buildLineAttritionDetails,
  buildLineQuoteQuantities,
  buildQuotesPayload,
  buildQuotesSnapshot,
  getFilledQuoteQuantities,
  isAttrQtyColumn,
  isAttritionQtyColumn,
  isRealBomLine,
  parseQuoteFromAttrColumn,
  quoteSlotNumbers,
  reqQtyColumn,
  syncQuoteQtyFromAttrition,
} from "../../../constants/quoteQuantities";
import {
  DIGIKEY_REFRESH_DETAILS,
  DIGIKEY_SAVE_OBSOLETE_ALTERNATES,
  DIGIKEY_VIEW_OPTIONS,
  BOM_ISSUE_REPORT,
  GET_BOMCHECKLISTS,
  GET_BOMLINES_SCRAPPED_PERCENT,
  GET_QUOTE,
} from "../../../constants/urls";
import { apiErrorMessage, toaster } from "../../../function";
import BomIssuesButton from "../../Buttons/BomIssuesButton";
import SyncMissingInfoButton from "../../Buttons/SyncMissingInfoButton";
import DownloadButton from "../../Buttons/DownloadButton";
import EmailButton from "../../Buttons/EmailButton";
import NeedAttentionButton from "../../Buttons/NeedAttentionButton";
import Layouts from "../../Layouts";
import { OverlayLoader } from "../../Loader/index";
import { TextLabel } from "../../Styled";
import MissingAttritionModal from "../Attrition/MissingAttritionModal";
import {
  buildMissingAttritionRows,
  collectBomPackages,
} from "../Attrition/validation";
import BomIssueReportModal from "./BomIssueReportModal";
import { SelectedAlternateMpnRow } from "../../AlternateRecommendationBadge";
import SyncMissingInfoModal from "./SyncMissingInfoModal";
import ExportExcel from "./ExportExcel";
import "./Home.css";
import { DropBox, FileInfo } from "./HomeStyled";
import ImportFromHistory from "./ImportFromHistory";
import ImportFromHistoryModal from "./ImportFromHistoryModal";
import ImportPreviewModal from "./ImportPreviewModal";
import ObsoletePartsReviewModal from "./ObsoletePartsReviewModal";
import UnmatchedPartsReviewModal from "./UnmatchedPartsReviewModal";

/** Parallel DigiKey/Oxylabs refreshes — one sticky session per PHP request. */
const SYNC_MISSING_INFO_CONCURRENCY = 4;
const VIEW_OPTIONS_CONCURRENCY = 4;

const formatQuoteAmount = (value, currency, fallback = "N/A") => {
  if (value == null || value === "") {
    return fallback;
  }
  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return fallback;
  }
  return `${currency || "$"}${amount.toFixed(2)}`;
};

const parseDisplayedQuoteAmount = (value) => {
  if (value == null || value === "") {
    return 0;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }
  let text = "";
  if (typeof value === "object") {
    if (Array.isArray(value.richText)) {
      text = value.richText.map((part) => part.text || "").join("");
    } else if (Array.isArray(value.text)) {
      text = value.text.map((part) => part.text || "").join("");
    } else {
      text = String(value);
    }
  } else {
    text = String(value);
  }
  if (/n\/a/i.test(String(text).trim())) {
    return 0;
  }
  const amount = parseFloat(String(text).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(amount) ? amount : 0;
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.importSimIntervalId = null;
    this.scrappingPercentTimeoutId = null;
    this.scrappingPercentAbortController = null;
    this.scrappingPercentPollGeneration = 0;
    this.syncMissingInfoItems = [];
    this.syncMissingInfoInFlight = false;
    this.syncMissingInfoNeedsDrain = false;
    this.viewOptionsInFlight = new Map();
    this.viewOptionsQueue = [];
    this.viewOptionsAbortControllers = new Map();
    this.pendingOpenViewOptionsMpn = "";
    this.state = {
      isLoading: false,
      loadingMessage: "",
      importSimPercent: 0,
      scrappingPercent: 0,
      getScrappingPercent: false,
      isAuth: true,
      previewData: false,
      importFromHistoryModalOpen: false,
      importFinish: props.importRecordes.bomlines.length ? true : false,
      exportEnable: props.importRecordes.bomlines.length ? true : false,
      data: [],
      file: [],
      highlightedBox: false,
      today: new Date(),
      quoteData: {},
      quoteVendors:
        this.props.user.user.role_id === 3 ? "Approves" : "Approves",
      currancy: "",
      ...buildInitialQuoteRefState(),
      showNeedAttentionRows: false,
      sheets: [],
      bomChecklists: [],
      missingAttritionRows: [],
      showMissingAttritionModal: false,
      enrichmentProgress: null,
      showObsoletePartsModal: false,
      obsoletePartsFocusKey: "",
      showUnmatchedPartsModal: false,
      unmatchedModalLine: null,
      showIssueReportModal: false,
      showSyncMissingInfoModal: false,
      syncMissingInfoItems: [],
      syncMissingInfoRunning: false,
      viewOptionsStatus: {},
      attritionByPackage: null,
      tariffTotal: 0,
      freightTotal: 0,
      refreshingDigiKeyLineKey: "",
    };
  }

  getQuotedVendorNames = (bomlines, quoteSlot = null) =>
    collectUniqueQuotedVendors(
      bomlines || this.props.importRecordes?.bomlines,
      quoteSlot,
    );

  getQuotedVendorCount = (bomlines, quoteSlot = null) =>
    countUniqueQuotedVendors(
      bomlines || this.props.importRecordes?.bomlines,
      quoteSlot,
    );

  getSelectedVendorCount = () => this.getQuotedVendorCount();

  isSyncMissingInfoRunning = () => {
    if (this.syncMissingInfoInFlight || this.state.syncMissingInfoRunning) {
      return true;
    }
    return this.getSyncMissingInfoItems().some(
      (item) => item.status === "pending" || item.status === "syncing",
    );
  };

  getSyncMissingInfoBadgeCount = () => {
    const successMpns = new Set(
      this.getSyncMissingInfoItems()
        .filter((item) => item.status === "success")
        .map((item) =>
          String(item.mpn || "")
            .trim()
            .toUpperCase(),
        )
        .filter(Boolean),
    );
    return collectSelectedUnmatchedNeedingSync(
      this.props.importRecordes?.bomlines,
    ).filter((line) => {
      const mpn = String(line.selected_alternate_mpn || "")
        .trim()
        .toUpperCase();
      return mpn && !successMpns.has(mpn);
    }).length;
  };

  matchesQueuedSyncLine = (row, item) => {
    if (lineMatchesSelectedAlternateMpn(row, item?.mpn)) {
      return true;
    }
    const originalKey = String(item?.originalMpn || "")
      .trim()
      .toLowerCase();
    if (!originalKey) {
      return false;
    }
    return (
      String(
        row.unmatched_original_mpn || row.manufacturer_part_number || "",
      )
        .trim()
        .toLowerCase() === originalKey
    );
  };

  notifySyncInProgress = () => {
    const now = Date.now();
    if (this.syncToastAt && now - this.syncToastAt < 2500) {
      return;
    }
    this.syncToastAt = now;
    toaster(ToastsStore, "warning", "Some Data are still syncing");
  };

  getFreightTotal = (bomlines) => {
    const costPerVendor = Number(
      this.props.systemSettings?.FREIGHT_COST_PER_VENDOR,
    );
    const vendorCount = this.getQuotedVendorCount(bomlines);
    return (
      vendorCount * (Number.isFinite(costPerVendor) ? costPerVendor : 0)
    );
  };

  getExportTotals = (bomlines) => {
    const lines = bomlines || this.props.importRecordes?.bomlines;
    const freightVendorCount = this.getQuotedVendorCount(lines);
    const vendorNames = this.getQuotedVendorNames(lines);
    const freightCostPerVendor =
      Number(this.props.systemSettings?.FREIGHT_COST_PER_VENDOR) || 0;
    const computedFreight =
      Math.round(freightVendorCount * freightCostPerVendor * 100) / 100;
    return {
      freightTotal:
        freightVendorCount > 0
          ? computedFreight
          : this.state.freightTotal != null
            ? this.state.freightTotal
            : this.getFreightTotal(lines),
      tariffTotal: this.state.tariffTotal || 0,
      currency: this.state.currancy || "$",
      tariffPercentage:
        Number(this.props.systemSettings?.TARIFF_PERCENTAGE) || 0,
      freightCostPerVendor,
      freightVendorCount,
      vendorNames,
    };
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.getScrappingPercent && this.state.getScrappingPercent) {
      this.stopImportSimulation();
      this.startScrappingPercentPoll();
    }
    if (prevState.getScrappingPercent && !this.state.getScrappingPercent) {
      this.stopScrappingPercentPoll();
    }

    // Simulated progress bar during BOM import (not file reading, not quote polling,
    // not obsolete-alternate save — that drives importSimPercent itself).
    const loadingStarted = !prevState.isLoading && this.state.isLoading;
    const loadingStopped = prevState.isLoading && !this.state.isLoading;
    const msg = this.state.loadingMessage || "";
    const isObsoleteSaveLoader =
      msg.startsWith("Saving selections") ||
      msg.includes("DigiKey data for") ||
      msg.includes("Enriching part details") ||
      msg === "Done!" ||
      msg.includes("Almost done") ||
      msg.includes("Enriched ") ||
      msg.includes("DigiKey enrichment");
    if (
      loadingStarted &&
      !this.state.getScrappingPercent &&
      this.state.loadingMessage !== "Reading CSV file, please wait..." &&
      !isObsoleteSaveLoader
    ) {
      this.startImportSimulation();
    }
    if (loadingStopped) {
      this.stopImportSimulation();
    }

    if (loadingStarted) {
      this.abortViewOptionsFetches();
    }

    if (loadingStopped && this.state.importFinish) {
      this.prefetchUnmatchedViewOptions();
    }

    this.ensureAutoSyncMissingInfo();
  }

  componentDidMount() {
    if (this.state.importFinish && !this.state.isLoading) {
      this.prefetchUnmatchedViewOptions();
    }
    this.ensureAutoSyncMissingInfo();
  }

  startImportSimulation = () => {
    if (this.importSimIntervalId) {
      clearInterval(this.importSimIntervalId);
    }
    this.setState({ importSimPercent: 5 });
    this.importSimIntervalId = setInterval(() => {
      this.setState((prev) => {
        const next =
          prev.importSimPercent + (88 - prev.importSimPercent) * 0.07;
        return { importSimPercent: Math.round(Math.min(next, 88)) };
      });
    }, 900);
  };

  stopImportSimulation = () => {
    if (this.importSimIntervalId) {
      clearInterval(this.importSimIntervalId);
      this.importSimIntervalId = null;
    }
    this.setState({ importSimPercent: 0, loadingMessage: "" });
  };

  UNSAFE_componentWillMount() {
    this.getBomChecklist(this.props.user.token);
    if (this.state.isAuth) {
      this.props.getColumns(this.props.user.token);
      this.props.getColumnAliases(this.props.user.token);
      this.props.getSystemSettings(this.props.user.token);
    }
    if (this.props.importRecordes.quotes) {
      let quoteData = {};
      this.props.importRecordes.quotes.map((item, index) => {
        quoteData[`quote${index + 1}`] = item[`quote${index + 1}`];
        return this.setState({
          [`quoteRef${index + 1}`]: item[`quoteRef${index + 1}`],
          [`percentageRef${index + 1}`]: item[`percentageRef${index + 1}`],
        });
      });

      this.setState({ quoteData });
    }
  }

  componentWillUnmount() {
    this.stopScrappingPercentPoll();
    this.stopImportSimulation();
    this.abortViewOptionsFetches();
    this.setState({ isAuth: false });
  }

  stopScrappingPercentPoll = () => {
    this.scrappingPercentPollGeneration += 1;
    if (this.scrappingPercentTimeoutId) {
      clearTimeout(this.scrappingPercentTimeoutId);
      this.scrappingPercentTimeoutId = null;
    }
    if (this.scrappingPercentAbortController) {
      this.scrappingPercentAbortController.abort();
      this.scrappingPercentAbortController = null;
    }
  };

  startScrappingPercentPoll = () => {
    this.stopScrappingPercentPoll();
    this.makeApiCall(
      this.props.user.token,
      this.scrappingPercentPollGeneration,
    );
  };

  makeApiCall = (token, generation) => {
    if (generation !== this.scrappingPercentPollGeneration) {
      return;
    }
    if (!this.state.getScrappingPercent) {
      return;
    }
    if (this.scrappingPercentAbortController) {
      this.scrappingPercentAbortController.abort();
    }
    const abortController = new AbortController();
    this.scrappingPercentAbortController = abortController;

    fetch(GET_BOMLINES_SCRAPPED_PERCENT, {
      method: "GET",
      headers: {
        authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      signal: abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (generation !== this.scrappingPercentPollGeneration) {
          return;
        }
        const percent = Number(data?.percent);
        const bounded = Number.isFinite(percent)
          ? Math.max(0, Math.min(100, percent))
          : 0;
        this.setState({ scrappingPercent: bounded.toFixed(2) });
        if (this.state.getScrappingPercent === true && bounded < 100) {
          this.scrappingPercentTimeoutId = setTimeout(() => {
            this.makeApiCall(token, generation);
          }, 3000);
        }
      })
      .catch((error) => {
        if (error?.name === "AbortError") {
          return;
        }
        if (generation !== this.scrappingPercentPollGeneration) {
          return;
        }
        this.setState({ error });
        if (this.state.getScrappingPercent === true) {
          this.scrappingPercentTimeoutId = setTimeout(() => {
            this.makeApiCall(token, generation);
          }, 3000);
        }
      });
  };

  getBomChecklist = async (token) => {
    fetch(GET_BOMCHECKLISTS, {
      method: "GET",
      headers: {
        authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    }) // Replace with your API endpoint
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ bomChecklists: data?.data });
      })
      .catch((error) => {
        this.setState({ error }); // Update state with error
      });
  };

  toggleModal = () => {
    this.inputRef.current.value = "";
    return this.setState({ previewData: !this.state.previewData });
  };

  toggleImportFromHistoryModal = () => {
    this.setState({
      importFromHistoryModalOpen: !this.state.importFromHistoryModalOpen,
    });
  };

  closeImportFromHistoryModal = () => {
    this.setState({
      importFromHistoryModalOpen: false,
    });
  };

  showBomLines = (value) => {
    this.clearQuote();
    return this.setState({
      importFinish: value,
      exportEnable: value,
      attritionByPackage: null,
    });
  };

  onMissingAttritions = (rows) => {
    this.setState({
      missingAttritionRows: rows || [],
      showMissingAttritionModal: true,
    });
  };

  onMissingAttritionsSaved = async () => {
    this.setState({
      missingAttritionRows: [],
      showMissingAttritionModal: false,
      attritionByPackage: null,
    });
    await this.refreshAttritionColumns({ forceReload: true });
  };

  checkMissingAttritionsForLines = async (bomlines) => {
    const roleId = this.props.user?.user?.role_id;
    if (roleId !== 1 && roleId !== 2) {
      return;
    }

    try {
      const { packages, leadByPackage } = collectBomPackages(bomlines);
      if (!packages.length) {
        return;
      }

      const res = await this.props.checkAttritionPackages(
        this.props.user.token,
        packages,
      );
      if (!(res && res.code >= 200 && res.code < 400)) {
        return;
      }

      const missingPackages = Array.isArray(res.data) ? res.data : [];
      if (!missingPackages.length) {
        return;
      }

      const rows = buildMissingAttritionRows(missingPackages, leadByPackage);
      if (rows.length > 0) {
        this.onMissingAttritions(rows);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onImportPartsReview = (bomlines) => {
    const obsoleteLines = collectObsoleteBomLines(bomlines || []);
    if (obsoleteLines.length) {
      this.setState({
        showObsoletePartsModal: true,
        obsoletePartsFocusKey: getLineReviewKey(obsoleteLines[0]),
      });
    }
  };

  onObsoletePartsReview = (bomlines) => {
    this.onImportPartsReview(bomlines);
  };

  openUnmatchedPartsReviewModal = (line) => {
    if (!isUnmatchedLine(line)) {
      return;
    }
    const current =
      (this.props.importRecordes.bomlines || []).find((row) =>
        matchesBomLine(row, line),
      ) || line;
    const mpn = getUnmatchedOriginalMpn(current);
    const key = mpn.toUpperCase();
    const selectableCount = getUnmatchedViewOptionsCache(current).length;
    if (selectableCount > 0) {
      this.pendingOpenViewOptionsMpn = "";
      this.setState({
        showUnmatchedPartsModal: true,
        unmatchedModalLine: current,
      });
      return;
    }
    if (current.substitutes_loaded === true) {
      this.pendingOpenViewOptionsMpn = "";
      toaster(
        ToastsStore,
        "error",
        `${mpn || "This part"} has 0 suggested parts.`,
      );
      return;
    }
    this.pendingOpenViewOptionsMpn = key;
    this.enqueueViewOptionsFetch(current);
  };

  closeUnmatchedPartsReviewModal = () => {
    const openKey = getUnmatchedOriginalMpn(
      this.state.unmatchedModalLine,
    ).toUpperCase();
    if (this.pendingOpenViewOptionsMpn === openKey) {
      this.pendingOpenViewOptionsMpn = "";
    }
    this.setState({
      showUnmatchedPartsModal: false,
      unmatchedModalLine: null,
    });
  };

  setViewOptionsStatus = (key, status) => {
    if (!key) {
      return;
    }
    this.setState((prev) => {
      if (prev.viewOptionsStatus[key] === status) {
        return null;
      }
      return {
        viewOptionsStatus: {
          ...prev.viewOptionsStatus,
          [key]: status,
        },
      };
    });
  };

  canRunViewOptionsFetch = () =>
    !this.state.isLoading && !this.state.getScrappingPercent;

  abortViewOptionsFetches = () => {
    this.viewOptionsQueue = [];
    this.pendingOpenViewOptionsMpn = "";
    this.viewOptionsAbortControllers.forEach((controller) => {
      try {
        controller.abort();
      } catch (error) {
        // Ignore abort errors while import/history takes over.
      }
    });
    this.viewOptionsAbortControllers.clear();
    this.viewOptionsInFlight.clear();
  };

  prefetchUnmatchedViewOptions = () => {
    if (!this.canRunViewOptionsFetch()) {
      return;
    }
    collectUnmatchedBomLines(this.props.importRecordes.bomlines || []).forEach(
      (line) => this.enqueueViewOptionsFetch(line),
    );
  };

  enqueueViewOptionsFetch = (line) => {
    if (!this.canRunViewOptionsFetch()) {
      return;
    }
    const mpn = getUnmatchedOriginalMpn(line);
    if (!mpn) {
      return;
    }
    const key = mpn.toUpperCase();
    if (lineHasCachedViewOptions(line)) {
      this.setViewOptionsStatus(key, "ready");
      return;
    }
    if (this.viewOptionsInFlight.has(key)) {
      this.setViewOptionsStatus(key, "loading");
      return;
    }
    if (this.viewOptionsQueue.some((job) => job.key === key)) {
      this.setViewOptionsStatus(key, "loading");
      return;
    }
    this.viewOptionsQueue.push({ key, mpn });
    this.setViewOptionsStatus(key, "loading");
    this.pumpViewOptionsQueue();
  };

  pumpViewOptionsQueue = () => {
    if (!this.canRunViewOptionsFetch()) {
      return;
    }
    while (
      this.viewOptionsQueue.length &&
      this.viewOptionsInFlight.size < VIEW_OPTIONS_CONCURRENCY
    ) {
      const job = this.viewOptionsQueue.shift();
      if (!job || this.viewOptionsInFlight.has(job.key)) {
        continue;
      }
      this.viewOptionsInFlight.set(job.key, true);
      this.fetchViewOptionsForMpn(job).finally(() => {
        this.viewOptionsInFlight.delete(job.key);
        this.viewOptionsAbortControllers.delete(job.key);
        this.pumpViewOptionsQueue();
      });
    }
  };

  applyViewOptionsToBomLines = (mpn, options, loaded = true) => {
    if (!this.canRunViewOptionsFetch()) {
      return this.props.importRecordes.bomlines || [];
    }
    const key = String(mpn || "")
      .trim()
      .toUpperCase();
    const patch = (row) => {
      if (
        !isUnmatchedLine(row) ||
        getUnmatchedOriginalMpn(row).toUpperCase() !== key
      ) {
        return row;
      }
      const inStock = (Array.isArray(options) ? options : []).filter(
        (item) =>
          String(
            item?.manufacturer_part_number || item?.manufacturerPartNumber || "",
          ).trim() !== "" && suggestedPartHasStock(item),
      );
      return {
        ...row,
        substitutes: inStock,
        substitutes_loaded: loaded,
        alternate_count: inStock.length,
      };
    };
    const bomlines = organizeBomByMountingType(
      (this.props.importRecordes.bomlines || []).map(patch),
    );
    const excelData = organizeBomByMountingType(
      (this.props.importRecordes.excelData || []).map(patch),
    );
    this.props.updateQuotes({
      bomlines,
      excelData,
      quotes: this.props.importRecordes.quotes || [],
      issue_report: this.props.importRecordes.issue_report,
    });
    if (
      this.state.showUnmatchedPartsModal &&
      getUnmatchedOriginalMpn(this.state.unmatchedModalLine).toUpperCase() ===
        key
    ) {
      const updated =
        bomlines.find((row) =>
          matchesBomLine(row, this.state.unmatchedModalLine),
        ) || bomlines.find((row) => getUnmatchedOriginalMpn(row).toUpperCase() === key);
      if (!updated || getUnmatchedViewOptionsCache(updated).length < 1) {
        this.closeUnmatchedPartsReviewModal();
      } else {
        this.setState({ unmatchedModalLine: updated });
      }
    }
    return bomlines;
  };

  openViewOptionsIfPending = (mpn) => {
    const key = String(mpn || "")
      .trim()
      .toUpperCase();
    if (!key || this.pendingOpenViewOptionsMpn !== key) {
      return;
    }
    if (this.state.showUnmatchedPartsModal) {
      return;
    }
    const line = collectUnmatchedBomLines(
      this.props.importRecordes.bomlines || [],
    ).find((row) => getUnmatchedOriginalMpn(row).toUpperCase() === key);
    if (!line || getUnmatchedViewOptionsCache(line).length < 1) {
      this.pendingOpenViewOptionsMpn = "";
      return;
    }
    this.pendingOpenViewOptionsMpn = "";
    this.setState({
      showUnmatchedPartsModal: true,
      unmatchedModalLine: line,
    });
  };

  fetchViewOptionsForMpn = async ({ key, mpn }) => {
    if (!this.canRunViewOptionsFetch()) {
      return;
    }
    const token = this.props.user.token;
    const controller = new AbortController();
    this.viewOptionsAbortControllers.set(key, controller);
    this.setViewOptionsStatus(key, "loading");
    const url =
      localStorage.getItem("isDebug") === "1"
        ? `${DIGIKEY_VIEW_OPTIONS}?debug=1&part_number=${encodeURIComponent(mpn)}`
        : `${DIGIKEY_VIEW_OPTIONS}?part_number=${encodeURIComponent(mpn)}`;

    try {
      const res = await fetch(url, {
        method: "GET",
        signal: controller.signal,
        headers: {
          authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      });
      if (!this.canRunViewOptionsFetch()) {
        return;
      }
      const data = await res.json();
      if (!this.canRunViewOptionsFetch()) {
        return;
      }
      if (
        !data ||
        data.code == null ||
        !(data.code >= 200 && data.code < 400)
      ) {
        this.setViewOptionsStatus(key, "error");
        return;
      }
      const loaded = data.data?.options || data.data?.substitutes || [];
      this.applyViewOptionsToBomLines(
        mpn,
        Array.isArray(loaded) ? loaded : [],
        true,
      );
      this.setViewOptionsStatus(key, "ready");
      this.openViewOptionsIfPending(mpn);
    } catch (error) {
      if (error && error.name === "AbortError") {
        return;
      }
      if (this.canRunViewOptionsFetch()) {
        this.setViewOptionsStatus(key, "error");
      }
    }
  };

  renderUnmatchedViewOptionsAction = (item, idleLabel = "") => {
    const key = getUnmatchedOriginalMpn(item).toUpperCase();
    const status = this.state.viewOptionsStatus[key];
    const cached = lineHasCachedViewOptions(item);
    const isLoading =
      !cached &&
      (status === "loading" || this.viewOptionsInFlight.has(key));
    const isError = !cached && status === "error";
    const count = getUnmatchedViewOptionsCache(item).length;
    const loaded = item.substitutes_loaded === true || cached;
    const readyLabel =
      idleLabel ||
      (loaded || count > 0
        ? `${UNMATCHED_VIEW_OPTIONS_LABEL} (${count})`
        : UNMATCHED_VIEW_OPTIONS_LABEL);
    const label = isLoading
      ? UNMATCHED_VIEW_OPTIONS_LOADING_LABEL
      : isError
        ? UNMATCHED_VIEW_OPTIONS_RETRY_LABEL
        : readyLabel;
    const canOpenModal = isLoading || isError || count > 0;

    return (
      <button
        type="button"
        className={classNames("unmatched-select-link", {
          "is-loading": isLoading,
          "is-disabled": !canOpenModal && loaded && count < 1,
        })}
        disabled={!canOpenModal && loaded && count < 1}
        onClick={(e) => {
          e.stopPropagation();
          if (!canOpenModal) {
            return;
          }
          this.openUnmatchedPartsReviewModal(item);
        }}
      >
        {isLoading ? (
          <i className="fa fa-spinner fa-spin unmatched-view-options-spinner" aria-hidden="true" />
        ) : null}
        {label}
      </button>
    );
  };

  onUnmatchedPartsSaved = ({ line, alternate, options }) => {
    const preferredAlternate = preferAlternateWithEnrichment(alternate, alternate);
    const patchLine = (row) =>
      matchesBomLine(row, line)
        ? applySelectedUnmatchedPartToLine(row, preferredAlternate, options)
        : row;

    const bomlines = organizeBomByMountingType(
      (this.props.importRecordes.bomlines || []).map(patchLine),
    );
    const excelData = organizeBomByMountingType(
      (this.props.importRecordes.excelData || []).map(patchLine),
    );

    this.props.updateQuotes({
      bomlines,
      excelData,
      quotes: this.props.importRecordes.quotes || [],
      issue_report: this.props.importRecordes.issue_report,
    });

    this.closeUnmatchedPartsReviewModal();
    toaster(ToastsStore, "success", "Suggested part queued.");
    this.enqueueSyncMissingInfoParts(this.buildSyncMissingInfoItems(bomlines), {
      autoStart: true,
      openModal: false,
      bomlines,
      excelData,
    });
    this.persistUnmatchedSelection(line, alternate);
    this.checkMissingAttritionsForLines(bomlines);
    return true;
  };

  refreshBomIssueReport = async () => {
    const bomId = this.props.importRecordes.bomId;
    const token = this.props.user && this.props.user.token;
    if (!bomId || !token) {
      return null;
    }

    try {
      const res = await fetch(BOM_ISSUE_REPORT(bomId), {
        method: "POST",
        headers: {
          authorization: "Bearer " + token,
        },
      });
      const body = await res.json();
      if (
        body &&
        body.code >= 200 &&
        body.code < 400 &&
        body.data &&
        typeof body.data === "object"
      ) {
        this.props.updateQuotes({
          quotes: this.props.importRecordes.quotes || [],
          issue_report: body.data,
        });
        return body.data;
      }
    } catch (error) {
      // Keep the last known report if refresh fails.
    }

    return null;
  };

  openBomIssueReport = () => {
    this.setState({ showIssueReportModal: true });
    this.refreshBomIssueReport();
  };

  persistUnmatchedSelection = async (line, alternate) => {
    const token = this.props.user.token;
    try {
      const res = await fetch(DIGIKEY_SAVE_OBSOLETE_ALTERNATES, {
        method: "POST",
        headers: {
          authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          selections: [
            {
              obsolete_part_id: line.part_id || null,
              obsolete_part_number:
                line.unmatched_original_mpn || line.manufacturer_part_number,
              manufacturer: line.manufacturer || "",
              selection_type: "unmatched",
              alternate,
            },
          ],
          bom_id: this.props.importRecordes.bomId || null,
        }),
      });
      const saveResponse = await res.json();
      const failureMessage = getDigiKeyAlternateSaveFailureMessage(
        saveResponse,
        "Failed to save suggested part selection.",
      );
      if (failureMessage) {
        toaster(ToastsStore, "error", failureMessage);
        return;
      }
      const issueReport =
        saveResponse && saveResponse.data && saveResponse.data.issue_report;
      if (issueReport) {
        this.props.updateQuotes({
          quotes: this.props.importRecordes.quotes || [],
          issue_report: issueReport,
        });
      }
    } catch (error) {
      toaster(ToastsStore, "error", "Failed to save suggested part selection.");
    }
  };

  buildSyncMissingInfoItems = (bomlines) =>
    collectSelectedUnmatchedNeedingSync(bomlines).map((line) => {
      const mpn = getDigiKeyRefreshPartNumber(line);
      return {
        key: getDigiKeyRefreshLineKey(line) || mpn,
        mpn,
        manufacturer: String(line.selected_alternate_manufacturer || "").trim(),
        originalMpn: getDigiKeyRefreshOriginalPartNumber(line),
        status: "pending",
        progress: 0,
        message: "",
      };
    });

  getSyncMissingInfoItems = () =>
    Array.isArray(this.syncMissingInfoItems)
      ? this.syncMissingInfoItems
      : this.state.syncMissingInfoItems || [];

  setSyncMissingInfoItems = (items) => {
    this.syncMissingInfoItems = items;
    this.setState({ syncMissingInfoItems: items });
  };

  reconcileSyncMissingInfoItems = (incoming = [], bomlines = null) => {
    const needed = this.buildSyncMissingInfoItems(
      bomlines || this.props.importRecordes.bomlines || [],
    );
    const existingByMpn = new Map();
    this.getSyncMissingInfoItems().forEach((item) => {
      const key = String(item.mpn || "")
        .trim()
        .toUpperCase();
      if (key) {
        existingByMpn.set(key, item);
      }
    });
    (incoming || []).forEach((item) => {
      const key = String(item.mpn || "")
        .trim()
        .toUpperCase();
      if (key && !existingByMpn.has(key)) {
        existingByMpn.set(key, item);
      }
    });

    const next = [];
    const seen = new Set();

    needed.forEach((item) => {
      const key = String(item.mpn || "")
        .trim()
        .toUpperCase();
      if (!key || seen.has(key)) {
        return;
      }
      seen.add(key);
      const existing = existingByMpn.get(key);
      if (existing && existing.status === "success") {
        next.push(existing);
        return;
      }
      if (!existing) {
        next.push(item);
        return;
      }
      next.push({
        ...item,
        key: existing.key || item.key,
        status: existing.status,
        progress: existing.progress,
        message: existing.message,
      });
    });

    existingByMpn.forEach((item, key) => {
      if (seen.has(key)) {
        return;
      }
      if (
        item.status === "pending" ||
        item.status === "syncing" ||
        item.status === "failed"
      ) {
        next.push(item);
        seen.add(key);
      }
    });

    this.setSyncMissingInfoItems(next);
    return next;
  };

  patchSyncMissingInfoItem = (mpn, patch) => {
    const key = String(mpn || "")
      .trim()
      .toUpperCase();
    this.setSyncMissingInfoItems(
      this.getSyncMissingInfoItems().map((item) =>
        String(item.mpn || "")
          .trim()
          .toUpperCase() === key
          ? { ...item, ...patch }
          : item,
      ),
    );
  };

  claimNextSyncMissingInfoItem = () => {
    const items = [...this.getSyncMissingInfoItems()];
    const index = items.findIndex((item) => item.status === "pending");
    if (index < 0) {
      return null;
    }
    const claimed = {
      ...items[index],
      status: "syncing",
      progress: 25,
      message: "",
    };
    items[index] = claimed;
    this.setSyncMissingInfoItems(items);
    return claimed;
  };

  enqueueSyncMissingInfoParts = (
    incoming,
    { autoStart = true, openModal = false, bomlines = null, excelData = null } = {},
  ) => {
    this.reconcileSyncMissingInfoItems(
      incoming,
      bomlines || this.props.importRecordes.bomlines,
    );
    if (openModal) {
      this.setState({ showSyncMissingInfoModal: true });
    }
    if (autoStart) {
      this.startSyncMissingInfo({
        bomlines: bomlines || this.props.importRecordes.bomlines,
        excelData: excelData || this.props.importRecordes.excelData,
      });
    }
  };

  ensureAutoSyncMissingInfo = () => {
    if (this.syncMissingInfoInFlight || this.state.syncMissingInfoRunning) {
      return;
    }
    const bomlines = this.props.importRecordes?.bomlines || [];
    const needed = this.buildSyncMissingInfoItems(bomlines);
    if (!needed.length) {
      return;
    }
    const queuedByMpn = new Map();
    this.getSyncMissingInfoItems().forEach((item) => {
      const key = String(item.mpn || "")
        .trim()
        .toUpperCase();
      if (key) {
        queuedByMpn.set(key, item);
      }
    });
    const needsStart = needed.some((item) => {
      const existing = queuedByMpn.get(
        String(item.mpn || "")
          .trim()
          .toUpperCase(),
      );
      return !existing || existing.status === "pending";
    });
    if (!needsStart) {
      return;
    }
    this.enqueueSyncMissingInfoParts(needed, {
      autoStart: true,
      openModal: false,
      bomlines,
      excelData: this.props.importRecordes?.excelData,
    });
  };

  openSyncMissingInfoModal = () => {
    const bomlines = this.props.importRecordes.bomlines;
    const excelData = this.props.importRecordes.excelData;
    this.reconcileSyncMissingInfoItems([], bomlines);
    this.setState({ showSyncMissingInfoModal: true });
    const hasWork = this.getSyncMissingInfoItems().some(
      (item) => item.status === "pending" || item.status === "failed",
    );
    if (hasWork) {
      this.startSyncMissingInfo({
        retryFailed: this.getSyncMissingInfoItems().some(
          (item) => item.status === "failed",
        ),
        bomlines,
        excelData,
      });
    }
  };

  closeSyncMissingInfoModal = () => {
    this.setState({ showSyncMissingInfoModal: false });
  };

  applyDigiKeyRefreshPartToRows = (rows, mpn, manufacturer, part, originalMpn = "") => {
    const enrichedAlternate = preferAlternateWithEnrichment(
      buildAlternateFromRefreshPart(
        {
          selected_alternate_mpn: mpn,
          selected_alternate_manufacturer: manufacturer,
        },
        part,
      ),
      {
        manufacturer_part_number: mpn,
        manufacturer,
      },
    );

    const originalKey = String(originalMpn || "").trim().toLowerCase();

    return rows.map((row) => {
      const matchesSelected = lineMatchesSelectedAlternateMpn(row, mpn);
      const matchesOriginal =
        originalKey !== "" &&
        String(
          row.unmatched_original_mpn || row.manufacturer_part_number || "",
        )
          .trim()
          .toLowerCase() === originalKey;
      if (!matchesSelected && !matchesOriginal) {
        return row;
      }
      if (isUnmatchedLine(row)) {
        if (!hasLineAlternateSelected(row) && !matchesSelected) {
          return row;
        }
        return markLineMissingInfoSynced(
          applySelectedUnmatchedPartToLine(
            row,
            enrichedAlternate,
            row.substitutes || null,
          ),
          mpn,
        );
      }
      return markLineMissingInfoSynced(
        applySelectedAlternateToLine(row, enrichedAlternate),
        mpn,
      );
    });
  };

  fetchDigiKeyRefreshPart = async (mpn, manufacturer, originalMpn = "") => {
    const token = this.props.user.token;
    try {
      const res = await fetch(DIGIKEY_REFRESH_DETAILS, {
        method: "POST",
        headers: {
          authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          part_number: mpn,
          manufacturer: String(manufacturer || "").trim(),
          original_part_number: String(originalMpn || "").trim(),
        }),
      });
      const refreshResponse = await res.json();
      if (
        !refreshResponse ||
        refreshResponse.code == null ||
        !(refreshResponse.code >= 200 && refreshResponse.code < 400) ||
        !refreshResponse.data?.refreshed ||
        !refreshResponse.data?.part
      ) {
        return {
          ok: false,
          message:
            (refreshResponse && refreshResponse.message) ||
            "Failed to fetch DigiKey details.",
        };
      }
      return { ok: true, part: refreshResponse.data.part, fromCache: !!refreshResponse.data.from_cache };
    } catch (error) {
      return { ok: false, message: "Failed to fetch DigiKey details." };
    }
  };

  startSyncMissingInfo = async ({
    retryFailed = false,
    bomlines: bomlinesArg = null,
    excelData: excelDataArg = null,
  } = {}) => {
    if (retryFailed) {
      this.setSyncMissingInfoItems(
        this.getSyncMissingInfoItems().map((item) =>
          item.status === "failed"
            ? { ...item, status: "pending", progress: 0, message: "" }
            : item,
        ),
      );
    }

    const hasWork = this.getSyncMissingInfoItems().some(
      (item) => item.status === "pending",
    );
    if (!hasWork) {
      this.syncMissingInfoInFlight = false;
      this.setState({ syncMissingInfoRunning: false });
      return;
    }

    if (this.syncMissingInfoInFlight) {
      this.syncMissingInfoNeedsDrain = true;
      this.setState({ syncMissingInfoRunning: true });
      return;
    }

    this.syncMissingInfoInFlight = true;
    this.setState({ syncMissingInfoRunning: true });

    let bomlines =
      bomlinesArg || this.props.importRecordes.bomlines || [];
    let excelData =
      excelDataArg || this.props.importRecordes.excelData || [];
    let successCount = 0;
    let failCount = 0;

    const applyResult = (item, result) => {
      if (result.ok) {
        bomlines = organizeBomByMountingType(
          this.applyDigiKeyRefreshPartToRows(
            mergeLatestUnmatchedSelections(
              bomlines,
              this.props.importRecordes.bomlines,
            ),
            item.mpn,
            item.manufacturer,
            result.part,
            item.originalMpn,
          ),
        );
        excelData = organizeBomByMountingType(
          this.applyDigiKeyRefreshPartToRows(
            mergeLatestUnmatchedSelections(
              excelData,
              this.props.importRecordes.excelData,
            ),
            item.mpn,
            item.manufacturer,
            result.part,
            item.originalMpn,
          ),
        );
        bomlines = (bomlines || []).map((row) =>
          this.matchesQueuedSyncLine(row, item)
            ? markLineMissingInfoSynced(row, item.mpn)
            : row,
        );
        excelData = (excelData || []).map((row) =>
          this.matchesQueuedSyncLine(row, item)
            ? markLineMissingInfoSynced(row, item.mpn)
            : row,
        );
        this.props.updateQuotes({
          bomlines,
          excelData,
          quotes: this.props.importRecordes.quotes || [],
          issue_report: this.props.importRecordes.issue_report,
        });
        this.patchSyncMissingInfoItem(item.mpn, {
          status: "success",
          progress: 100,
          message: "",
        });
        successCount += 1;
        return;
      }

      this.patchSyncMissingInfoItem(item.mpn, {
        status: "failed",
        progress: 100,
        message: result.message || "Failed to fetch",
      });
      failCount += 1;
    };

    const runWorker = async () => {
      while (true) {
        const item = this.claimNextSyncMissingInfoItem();
        if (!item) {
          return;
        }
        const tick = setInterval(() => {
          const current = this.getSyncMissingInfoItems().find(
            (row) =>
              String(row.mpn || "").trim().toUpperCase() ===
              String(item.mpn || "").trim().toUpperCase(),
          );
          if (!current || current.status !== "syncing") {
            return;
          }
          this.patchSyncMissingInfoItem(item.mpn, {
            progress: Math.min(85, Number(current.progress || 25) + 8),
          });
        }, 2500);
        try {
          const result = await this.fetchDigiKeyRefreshPart(
            item.mpn,
            item.manufacturer,
            item.originalMpn,
          );
          if (result.ok && result.fromCache) {
            this.patchSyncMissingInfoItem(item.mpn, { progress: 100 });
          }
          applyResult(item, result);
        } finally {
          clearInterval(tick);
        }
      }
    };

    try {
      do {
        this.syncMissingInfoNeedsDrain = false;
        const pendingCount = this.getSyncMissingInfoItems().filter(
          (item) => item.status === "pending",
        ).length;
        if (!pendingCount) {
          break;
        }
        const workerCount = Math.min(
          SYNC_MISSING_INFO_CONCURRENCY,
          pendingCount,
        );
        await Promise.all(
          Array.from({ length: workerCount }, () => runWorker()),
        );
      } while (
        this.syncMissingInfoNeedsDrain ||
        this.getSyncMissingInfoItems().some((item) => item.status === "pending")
      );
    } finally {
      this.syncMissingInfoInFlight = false;
      this.setState({ syncMissingInfoRunning: false });
    }

    if (!successCount && !failCount) {
      return;
    }

    if (failCount && successCount) {
      toaster(
        ToastsStore,
        "warning",
        `Synced ${successCount} part${successCount === 1 ? "" : "s"}. ${failCount} failed to fetch.`,
      );
    } else if (failCount) {
      toaster(
        ToastsStore,
        "error",
        failCount === 1
          ? "Failed to fetch DigiKey details."
          : `Failed to fetch DigiKey details for ${failCount} parts.`,
      );
    } else {
      toaster(
        ToastsStore,
        "success",
        successCount === 1
          ? "DigiKey details synced."
          : `Synced DigiKey details for ${successCount} parts.`,
      );
    }

    await this.refreshBomIssueReport();
  };

  openObsoletePartsReviewModal = (line) => {
    if (!isObsoleteLine(line)) {
      return;
    }
    this.setState({
      showObsoletePartsModal: true,
      obsoletePartsFocusKey: getObsoleteLineKey(line),
    });
  };

  handleObsoleteRowClick = (line, event) => {
    if (!isObsoleteLine(line)) {
      return;
    }
    if (
      event.target.closest(
        "input, button, a, select, textarea, label, .form-control",
      )
    ) {
      return;
    }
    this.openObsoletePartsReviewModal(line);
  };

  closeObsoletePartsReviewModal = () => {
    this.setState({
      showObsoletePartsModal: false,
      obsoletePartsFocusKey: "",
    });
  };

  handleIssueReportClick = (issue) => {
    if (!issue) {
      return;
    }

    const bomlines = this.props.importRecordes.bomlines || [];
    const matchLine = bomlines.find(
      (line) =>
        isRealBomLine(line) &&
        String(line.manufacturer_part_number || "")
          .trim()
          .toUpperCase() ===
          String(issue.manufacturer_part_number || "")
            .trim()
            .toUpperCase(),
    );

    if (
      issue.issue_type === "needs_alternate_selection" ||
      issue.issue_type === "invalid_mpn"
    ) {
      if (!isIssueRowActionable(issue, matchLine)) {
        toaster(
          ToastsStore,
          "error",
          `${issue.manufacturer_part_number || "This part"} has 0 suggested parts.`,
        );
        return;
      }
      this.setState({ showIssueReportModal: false });
      if (matchLine && isUnmatchedLine(matchLine)) {
        this.openUnmatchedPartsReviewModal(matchLine);
      } else if (matchLine && isObsoleteLine(matchLine)) {
        this.openObsoletePartsReviewModal(matchLine);
      }
      return;
    }

    if (issue.issue_type === "obsolete") {
      if (!isIssueRowActionable(issue, matchLine)) {
        toaster(
          ToastsStore,
          "error",
          `${issue.manufacturer_part_number || "This part"} has 0 suggested parts.`,
        );
        return;
      }
      this.setState({ showIssueReportModal: false });
      if (matchLine) {
        this.openObsoletePartsReviewModal(matchLine);
      } else {
        this.onObsoletePartsReview(bomlines);
      }
    }
  };

  onObsoletePartsSaved = async (selections) => {
    const token = this.props.user.token;
    const enrichmentProgressToken = `obs-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 10)}`;

    const apiSelections = selections.map(({ line, alternate }) => ({
      obsolete_part_id: line.part_id || null,
      obsolete_part_number:
        line.obsolete_part_number || line.manufacturer_part_number,
      selection_type: "obsolete",
      alternate,
    }));

    let saveResponse = null;

    try {
      const res = await fetch(DIGIKEY_SAVE_OBSOLETE_ALTERNATES, {
        method: "POST",
        headers: {
          authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          selections: apiSelections,
          bom_id: this.props.importRecordes.bomId || null,
          enrichment_progress_token: enrichmentProgressToken,
        }),
      });
      saveResponse = await res.json();
    } catch (error) {
      toaster(ToastsStore, "error", "Failed to save obsolete alternates.");
      throw new Error("Failed to save obsolete alternates.");
    }

    const failureMessage = getDigiKeyAlternateSaveFailureMessage(
      saveResponse,
      "Failed to save obsolete alternates.",
    );
    if (failureMessage) {
      toaster(ToastsStore, "error", failureMessage);
      throw new Error(failureMessage);
    }

    let bomlines = this.props.importRecordes.bomlines || [];
    let excelData = this.props.importRecordes.excelData || [];

    selections.forEach(({ line, alternate }) => {
      // DigiKey columns come from API alternate payload (now includes DigiKey enrich on save).
      const savedAlternate = getSavedAlternateFromResponse(
        saveResponse,
        alternate,
        {
          part_id: line.part_id,
          obsolete_part_number:
            line.obsolete_part_number || line.manufacturer_part_number,
        },
      );
      const preferredAlternate = preferAlternateWithEnrichment(
        savedAlternate,
        alternate,
      );

      const patchLine = (row) =>
        matchesBomLine(row, line)
          ? applySelectedAlternateToLine(
              {
                ...row,
                substitutes:
                  Array.isArray(line.substitutes) && line.substitutes.length
                    ? line.substitutes
                    : row.substitutes,
              },
              preferredAlternate,
            )
          : row;

      bomlines = bomlines.map(patchLine);
      excelData = excelData.map(patchLine);
    });

    // Re-apply SMT / Through-Hole section rows after DigiKey field updates.
    bomlines = organizeBomByMountingType(bomlines);
    excelData = organizeBomByMountingType(excelData);

    this.props.updateQuotes({
      bomlines,
      excelData,
      quotes: this.props.importRecordes.quotes || [],
      issue_report:
        (saveResponse.data && saveResponse.data.issue_report) ||
        this.props.importRecordes.issue_report,
    });

    toaster(ToastsStore, "success", "Obsolete alternates saved.");

    Promise.resolve()
      .then(() => this.checkMissingAttritionsForLines(bomlines))
      .then(() => this.refreshAttritionColumns({ forceReload: true }))
      .catch((error) => {
        console.log(error);
      });
  };

  refreshDigiKeyDetailsForLine = async (line) => {
    const refreshKey = getDigiKeyRefreshLineKey(line);
    const mpn = getDigiKeyRefreshPartNumber(line);
    const originalMpn = getDigiKeyRefreshOriginalPartNumber(line);
    if (!mpn || !refreshKey) {
      return;
    }
    if (
      this.state.refreshingDigiKeyLineKey ||
      this.state.syncMissingInfoRunning
    ) {
      return;
    }

    this.setState({ refreshingDigiKeyLineKey: refreshKey });

    try {
      const result = await this.fetchDigiKeyRefreshPart(
        mpn,
        line.selected_alternate_manufacturer || line.manufacturer || "",
        originalMpn,
      );
      if (!result.ok) {
        toaster(
          ToastsStore,
          "error",
          result.message || "Failed to refresh DigiKey details.",
        );
        return;
      }

      const bomlines = organizeBomByMountingType(
        this.applyDigiKeyRefreshPartToRows(
          this.props.importRecordes.bomlines || [],
          mpn,
          line.selected_alternate_manufacturer || line.manufacturer || "",
          result.part,
          originalMpn,
        ),
      );
      const excelData = organizeBomByMountingType(
        this.applyDigiKeyRefreshPartToRows(
          this.props.importRecordes.excelData || [],
          mpn,
          line.selected_alternate_manufacturer || line.manufacturer || "",
          result.part,
          originalMpn,
        ),
      );

      this.props.updateQuotes({
        bomlines,
        excelData,
        quotes: this.props.importRecordes.quotes || [],
      });

      toaster(ToastsStore, "success", "DigiKey details refreshed.");
      await this.refreshBomIssueReport();
    } catch (error) {
      toaster(ToastsStore, "error", "Failed to refresh DigiKey details.");
    } finally {
      this.setState({ refreshingDigiKeyLineKey: "" });
    }
  };

  loadAttritionMap = async ({ forceReload = false } = {}) => {
    if (!forceReload && this.state.attritionByPackage) {
      return this.state.attritionByPackage;
    }

    try {
      const res = await this.props.getAttritions(this.props.user.token);
      if (!(res && res.code >= 200 && res.code < 400)) {
        return this.state.attritionByPackage || {};
      }
      const map = buildAttritionPackageMap(res.data || []);
      this.setState({ attritionByPackage: map });
      return map;
    } catch (e) {
      console.log(e);
      return this.state.attritionByPackage || {};
    }
  };

  refreshAttritionColumns = async ({
    forceReload = false,
    preserveAttrEdits = false,
    quoteData = null,
  } = {}) => {
    const quotesSource = quoteData || this.state.quoteData || {};
    if (!this.props.importRecordes?.bomlines?.length) {
      return;
    }

    const hasQuotes = getFilledQuoteQuantities(quotesSource).length > 0;
    const attritionByPackage = hasQuotes
      ? await this.loadAttritionMap({ forceReload })
      : {};

    const bomlines = applyAttritionQtyColumns(
      this.props.importRecordes.bomlines,
      quotesSource,
      attritionByPackage,
      { preserveAttrEdits: hasQuotes && preserveAttrEdits },
    );

    this.props.updateQuotes({
      bomlines,
      quotes: this.props.importRecordes.quotes || [],
    });
  };

  handleAttrQtyChange = (rowIndex, column, value) => {
    const quoteQty = parseQuoteFromAttrColumn(column);
    const filledQuotes = getFilledQuoteQuantities(this.state.quoteData);
    const slotIndex = quoteQty ? filledQuotes.indexOf(String(quoteQty)) : -1;

    const bomlines = this.props.importRecordes.bomlines.map((line, index) => {
      if (index !== rowIndex) return line;
      const next = { ...line, [column]: value };
      if (slotIndex >= 0 && quoteQty) {
        const req = Number(next[reqQtyColumn(quoteQty)]) || 0;
        const attr = Number(value);
        next[`QuoteQty ${slotIndex + 1}`] =
          req + (Number.isFinite(attr) ? attr : 0);
      }
      return next;
    });
    this.props.updateQuotes({
      bomlines,
      quotes: this.props.importRecordes.quotes || [],
    });
  };

  fileUpload = (acceptFiles, index = 0) => {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    if (acceptFiles) {
      this.setState({
        isLoading: true,
        loadingMessage: "Reading CSV file, please wait...",
      });

      reader.onload = (e) => {
        try {
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {
            type: rABS ? "binary" : "array",
            bookVBA: true,
          });
          const wsname = wb.SheetNames[index];
          const ws = wb.Sheets[wsname];
          if (!ws) {
            throw new Error("Could not read the selected sheet.");
          }
          let data = XLSX.utils.sheet_to_json(ws, { defval: "", header: "A" });
          this.addColumnIndex(data);

          let sheet_array = wb.SheetNames?.map((sheet, sheetIndex) => ({
            id: sheetIndex,
            name: sheet,
          }));

          this.setState({
            isLoading: false,
            loadingMessage: "",
            data: data,
            previewData: true,
            file: acceptFiles,
            sheets: sheet_array,
          });
          localStorage.setItem(
            "fileName",
            acceptFiles && acceptFiles[0] ? acceptFiles[0].name : "",
          );
        } catch (error) {
          this.setState({
            isLoading: false,
            loadingMessage: "",
          });
        }
      };

      if (rABS) {
        reader.readAsBinaryString(acceptFiles[0]);
      } else {
        reader.readAsArrayBuffer(acceptFiles[0]);
      }
    }
  };

  addColumnIndex = (data) => {
    for (let i = 0; i < data.length; i++) {
      data[i] = Object.assign({ index: i + 1 }, data[i]);
    }
  };

  fillQuote = (e) => {
    const quoteData = {
      ...this.state.quoteData,
      [e.target.name]: e.target.value,
    };
    this.setState({ quoteData }, () => {
      this.refreshAttritionColumns({ quoteData });
    });
  };

  fillQuoteVendors = (e) => {
    if (this.props.user.user.role_id === 3) {
      return false;
    }
    return this.setState({ quoteVendors: e.target.value });
  };

  orignalField = async () => {
    const excelData = this.props.importRecordes?.excelData;
    if (Array.isArray(excelData) && excelData.length) {
      let excelKeys = Object.keys(excelData[0] || {});
      let orignalRecords = await excelData.map((item) => {
        excelKeys.forEach((key) => {
          if (
            key.indexOf("Quote ") !== -1 ||
            key.indexOf("BOM Manager Result ") !== -1 ||
            key.indexOf("QuoteQty ") !== -1 ||
            isAttritionQtyColumn(key)
          ) {
            item = _.omit(item, key);
          }
        });
        return item;
      });
      return orignalRecords;
    }
    return [];
  };

  resolveBomLineIndex = (ele, fallbackIndex) =>
    ele?._bomLineIndex != null ? ele._bomLineIndex : fallbackIndex;

  getPartsDetailKey = (data, ele, fallbackIndex) => {
    const lineIndex = this.resolveBomLineIndex(ele, fallbackIndex);
    const mpn = String(ele?.manufacturer_part_number || "").trim();
    if (!mpn || !data) {
      return null;
    }
    const key = `${mpn}_${lineIndex}`;
    return Object.prototype.hasOwnProperty.call(data, key) ? key : null;
  };

  getQuoteDistributorParam = (
    data,
    ele,
    postQuote,
    fallbackIndex,
    quoteSlot = 0,
  ) => {
    try {
      const detailKey = this.getPartsDetailKey(data, ele, fallbackIndex);
      if (!detailKey) {
        return null;
      }
      const quoteQty = parseInt(postQuote.quotes[quoteSlot], 10);
      const distributor = data[detailKey]?.[quoteQty]?.distributor;
      if (!distributor) {
        return null;
      }
      const distributorName = Object.keys(distributor)[0];
      return distributorName ? distributor[distributorName] : null;
    } catch {
      return null;
    }
  };

  getPartStatusDetails = (data, ele, postQuote, i) => {
    try {
      const distributorParam = this.getQuoteDistributorParam(
        data,
        ele,
        postQuote,
        i,
      );
      if (!distributorParam) {
        return ele["Part Status"] || "N/A";
      }
      let rohs_regex =
        /[Rr][Oo][Hh][Ss]\s*[Cc][Oo][Mm][Pp][Ll][Ii][Aa][Nn][Tt]\s*:\s*[Yy][Ee][Ss]/;
      const quotedRohs = resolveRohsStatus(distributorParam);
      const descriptionRohs = distributorParam["description"]?.match(rohs_regex)
        ? "ROHS Compliant: Yes"
        : "";
      const existingRohs = getRohsValueFromPartStatusCell(ele["Part Status"]);
      return {
        part_status: [
          {
            key: "ROHS Status",
            value: quotedRohs || descriptionRohs || existingRohs || "N/A",
          },
          {
            key: "Lifecycle Status",
            value: distributorParam["lifecycleStatus"] || "N/A",
          },
        ],
      };
    } catch {
      return "N/A";
    }
  };

  // getPartDescription = (data, ele, postQuote) => {
  //   try {
  //     let firstDistributorParam =
  //       data[ele["manufacturer_part_number"]][parseInt(postQuote.quotes[0])][
  //         "distributor"
  //       ];
  //     let firstDistributorParamkeyObject = Object.keys(
  //       firstDistributorParam
  //     )[0];
  //     let rohs_regex = /[Rr][Oo][Hh][Ss]\s*[Cc][Oo][Mm][Pp][Ll][Ii][Aa][Nn][Tt]\s*:\s*[Yy][Ee][Ss]/;
  //     return {
  //       description: [
  //         {
  //           key: "Description",
  //           value:
  //             firstDistributorParam[firstDistributorParamkeyObject][
  //               "description"
  //             ].match(rohs_regex) ? firstDistributorParam[firstDistributorParamkeyObject][
  //               "description"
  //             ].replace(rohs_regex, '') :
  //             firstDistributorParam[firstDistributorParamkeyObject][
  //               "description"
  //             ],
  //         },
  //         {
  //           key: "Digikey Description",
  //           value: firstDistributorParam[firstDistributorParamkeyObject]["short_description"],
  //         },
  //         {
  //           key: "Datasheet",
  //           link:
  //             firstDistributorParam[firstDistributorParamkeyObject][
  //               "datasheetLink"
  //             ],
  //           linkText: "Datasheet",
  //         }
  //       ],
  //     };
  //   } catch {
  //     return "N/A";
  //   }
  // };

  getDigikeyDescription = (data, ele, postQuote, i) => {
    try {
      const distributorParam = this.getQuoteDistributorParam(
        data,
        ele,
        postQuote,
        i,
      );
      return distributorParam?.short_description || "N/A";
    } catch {
      return "N/A";
    }
  };

  getDatasheet = (data, ele, postQuote, i) => {
    try {
      const distributorParam = this.getQuoteDistributorParam(
        data,
        ele,
        postQuote,
        i,
      );
      const link = distributorParam?.datasheetLink;
      if (!link) {
        return "N/A";
      }
      return {
        description: [{ key: "", link: link, linkText: "Datasheet" }],
      };
    } catch {
      return "N/A";
    }
  };

  getUsImportTariff = (data, ele, postQuote, i) => {
    try {
      const distributorParam = this.getQuoteDistributorParam(
        data,
        ele,
        postQuote,
        i,
      );
      return formatUsImportTariff(distributorParam?.usImportTariff);
    } catch {
      return "N/A";
    }
  };

  getCountryOfOrigin = (data, ele, postQuote, i) => {
    try {
      const distributorParam = this.getQuoteDistributorParam(
        data,
        ele,
        postQuote,
        i,
      );
      return distributorParam?.countryOfOrigin || "N/A";
    } catch {
      return "N/A";
    }
  };

  getPackage = (data, ele, postQuote, i) => {
    try {
      const distributorParam = this.getQuoteDistributorParam(
        data,
        ele,
        postQuote,
        i,
      );
      return resolvePackageValue(distributorParam) || "N/A";
    } catch {
      return "N/A";
    }
  };

  getLeadClassification = (data, ele, postQuote, i) => {
    try {
      const distributorParam = this.getQuoteDistributorParam(
        data,
        ele,
        postQuote,
        i,
      );
      return (
        distributorParam?.package_classification_label ||
        distributorParam?.package_classification ||
        "Unknown"
      );
    } catch {
      return "Unknown";
    }
  };

  getMountingType = (data, ele, postQuote, i) => {
    try {
      const distributorParam = this.getQuoteDistributorParam(
        data,
        ele,
        postQuote,
        i,
      );
      return (
        normalizeMountingType(
          distributorParam?.mounting_type,
          categoryTextForMounting(distributorParam),
        ) || "N/A"
      );
    } catch {
      return "N/A";
    }
  };

  addQuoteColummns = async (postQuote, parts) => {
    const excelData = await this.orignalField();
    if (!Array.isArray(excelData) || !excelData.length) {
      return [];
    }
    let data =
      parts && parts.partsDetail && typeof parts.partsDetail === "object"
        ? parts.partsDetail
        : {};
    let mfgPartkey = Object.keys(data);
    mfgPartkey = mfgPartkey.map((item) => item.replace(/_\d+$/, ""));
    const previousBomlines = this.props.importRecordes.bomlines || [];
    const findPreviousLine = (originalIndex) =>
      previousBomlines.find(
        (line) =>
          line &&
          !isBomSectionRow(line) &&
          line._bomLineIndex === originalIndex,
      ) || previousBomlines[originalIndex];

    let resolvedCurrency = this.state.currancy || "$";
    let updateRecords = await excelData.map((ele, i) => {
      const lineIndex = this.resolveBomLineIndex(ele, i);
      const detailKey = this.getPartsDetailKey(data, ele, i);

      postQuote.quotes.forEach((item, index) => {
        const prev = findPreviousLine(lineIndex);
        const req = prev ? Number(prev[reqQtyColumn(item)]) : NaN;
        const attr = prev ? Number(prev[attrQtyColumn(item)]) : NaN;
        if (Number.isFinite(req)) {
          ele["QuoteQty " + (index + 1)] =
            req + (Number.isFinite(attr) ? attr : 0);
        } else if (
          postQuote.line_quote_quantities &&
          postQuote.line_quote_quantities[lineIndex] &&
          postQuote.line_quote_quantities[lineIndex][String(item)] != null
        ) {
          ele["QuoteQty " + (index + 1)] =
            postQuote.line_quote_quantities[lineIndex][String(item)];
        } else {
          ele["QuoteQty " + (index + 1)] = ele["quantity"] * parseInt(item);
        }

        ele["manufacturer_part_number"] = String(
          ele["manufacturer_part_number"],
        ).trim();
        if (index === 0) {
          ele["Digikey Description"] = this.getDigikeyDescription(
            data,
            ele,
            postQuote,
            i,
          );
          ele["Datasheet"] = this.getDatasheet(data, ele, postQuote, i);
          ele["Package"] = this.getPackage(data, ele, postQuote, i);
          ele["Lead Classification"] = this.getLeadClassification(
            data,
            ele,
            postQuote,
            i,
          );
          const mountingType = this.getMountingType(data, ele, postQuote, i);
          ele["Mounting Type"] = mountingType;
          ele.mounting_type =
            mountingType && mountingType !== "N/A" ? mountingType : "";
          ele["Part Status"] = this.getPartStatusDetails(
            data,
            ele,
            postQuote,
            i,
          );
          ele["U.S. Import Tariff"] = this.getUsImportTariff(
            data,
            ele,
            postQuote,
            i,
          );
          ele["Country of Origin"] = this.getCountryOfOrigin(
            data,
            ele,
            postQuote,
            i,
          );
          ele._bomLineIndex = lineIndex;
        }
        if (detailKey && mfgPartkey.includes(ele["manufacturer_part_number"])) {
          const detailEntry = data[detailKey];
          const quoteEntry =
            detailEntry && typeof detailEntry === "object"
              ? detailEntry[parseInt(item, 10)] ||
                detailEntry[item] ||
                detailEntry[String(item)]
              : null;
          const distributorParam = quoteEntry?.distributor;
          if (
            !quoteEntry ||
            !distributorParam ||
            typeof distributorParam !== "object" ||
            Object.keys(distributorParam).length === 0
          ) {
            ele["BOM Manager Result " + (index + 1)] = {
              text: [{ class: "tdSubTitle", text: "No Result" }],
              class: "bg-light-maroon",
            };
            ele["Quote " + (index + 1)] = {
              text: [
                { class: "tdSubTitle", text: resolvedCurrency + "0.00" },
              ],
              class: "bg-yellow",
            };
            ele["Tariff Charge " + (index + 1)] = {
              text: [{ class: "tdSubTitle", text: "N/A" }],
              class: "bg-yellow",
            };
          } else {
            let keyObject = Object.keys(distributorParam)[0];
            let quoteStatus = distributorParam[keyObject]?.["outcome"];

            switch (quoteStatus) {
              case "notAvailable":
                ele["BOM Manager Result " + (index + 1)] = {
                  text: [{ class: "tdSubTitle", text: "Not Available" }],
                  class: "bg-light-maroon",
                };
                ele["Quote " + (index + 1)] = {
                  text: [
                    { class: "tdSubTitle", text: resolvedCurrency + "0.00" },
                  ],
                  class: "bg-yellow",
                };
                ele["Tariff Charge " + (index + 1)] = {
                  text: [{ class: "tdSubTitle", text: "N/A" }],
                  class: "bg-yellow",
                };

                break;
              case "multipleManufacturers":
                ele["BOM Manager Result " + (index + 1)] = {
                  text: [
                    { class: "tdRedSubTitle", text: "Multiple Manufacturers" },
                  ],
                  // class: "bg-light-maroon",
                };
                ele["Quote " + (index + 1)] = {
                  text: [
                    { class: "tdSubTitle", text: resolvedCurrency + "0.00" },
                  ],
                  class: "bg-yellow",
                };
                ele["Tariff Charge " + (index + 1)] = {
                  text: [{ class: "tdSubTitle", text: "N/A" }],
                  class: "bg-yellow",
                };

                break;
              case "success":
              case "insufficientQuantity":
                const quoteLine = findPreviousLine(lineIndex);
                let manufacturerName =
                  distributorParam[keyObject]["manufacturerName"];
                let isManufacturerMatch =
                  distributorParam[keyObject]["isManufacturerMatch"];
                let manufacturerPartNumber =
                  distributorParam[keyObject]["manufacturerPartNumber"];
                if (quoteLine && lineUsesAlternateForQuote(quoteLine)) {
                  manufacturerName =
                    distributorParam[keyObject][
                      "quotedAlternateManufacturer"
                    ] ||
                    quoteLine.selected_alternate_manufacturer ||
                    manufacturerName;
                  manufacturerPartNumber =
                    distributorParam[keyObject]["quotedAlternateMpn"] ||
                    quoteLine.selected_alternate_mpn ||
                    manufacturerPartNumber;
                  isManufacturerMatch = true;
                }
                let isPartMatch = distributorParam[keyObject]["isPartMatch"];
                if (quoteLine && lineUsesAlternateForQuote(quoteLine)) {
                  isPartMatch = true;
                }
                let unitPrice = distributorParam[keyObject]["unitPrice"];
                let availableStock =
                  distributorParam[keyObject]["availableStock"];
                let quoteQuantity =
                  distributorParam[keyObject]["quoteQuantity"];
                let priceQuote = distributorParam[keyObject]["priceQuote"];
                let currancy = distributorParam[keyObject]["currency"];
                let currancySymbol = currencyList.find(
                  (curr) => curr.title === currancy,
                ) || { symbol: resolvedCurrency || "$" };
                resolvedCurrency = currancySymbol.symbol;
                let moq = null;
                if (distributorParam[keyObject]["moq"]) {
                  moq = " | MOQ " + distributorParam[keyObject]["moq"];
                }

                let priceBreak =
                  quoteQuantity + " => " + resolvedCurrency + priceQuote;

                ele["BOM Manager Result " + (index + 1)] = {
                  text: [
                    {
                      class: isManufacturerMatch
                        ? "tdSubTitle"
                        : "tdItalicSubTitle",
                      text: manufacturerName,
                    },
                    { class: "tdSubTitle", text: " | " },
                    {
                      class: isPartMatch ? "tdSubTitle" : "tdItalicSubTitle",
                      text: manufacturerPartNumber,
                    },
                    { class: "tdSubTitle", text: " | " },
                    { class: "tdSubTitle", text: keyObject },
                    { class: "tdSubTitle", text: " | Cost: " },
                    { class: "tdSubTitle", text: unitPrice },
                    { class: "tdSubTitle", text: " | Available: " },
                    { class: "tdSubTitle", text: availableStock },
                    // quoteStatus === "insufficientQuantity"
                    //   ? { class: "tdItalicSubTitle", text: " | Available: " }
                    //   : {},
                    // quoteStatus === "insufficientQuantity"
                    //   ? { class: "tdItalicSubTitle", text: availableStock }
                    //   : {},

                    priceBreak !== ""
                      ? { class: "tdSubTitle", text: " | Price Break: " }
                      : {},
                    priceBreak !== ""
                      ? { class: "tdSubTitle", text: priceBreak }
                      : {},

                    moq != null ? { class: "tdItalicSubTitle", text: moq } : {},
                  ],
                  class:
                    quoteStatus === "insufficientQuantity"
                      ? "bg-gray-opacity"
                      : "bg-green",
                  title:
                    quoteStatus === "insufficientQuantity"
                      ? "Insufficient Quanity"
                      : "",
                };
                ele["Quote " + (index + 1)] = {
                  text: [
                    {
                      class: "tdSubTitle",
                      text: formatQuoteAmount(
                        quoteStatus === "insufficientQuantity"
                          ? 0
                          : quoteEntry.quotePrice,
                        resolvedCurrency,
                        `${resolvedCurrency || "$"}0.00`,
                      ),
                    },
                  ],
                  class:
                    data[detailKey]["is_lowest_price"] === true
                      ? "bg-green"
                      : " ",
                };
                ele["Tariff Charge " + (index + 1)] = {
                  text: [
                    {
                      class: "tdSubTitle",
                      text:
                        quoteStatus === "insufficientQuantity"
                          ? formatQuoteAmount(0, resolvedCurrency)
                          : formatQuoteAmount(
                              quoteEntry.tariffValue,
                              resolvedCurrency,
                            ),
                    },
                  ],
                  class:
                    data[detailKey]["is_lowest_price"] === true
                      ? "bg-green"
                      : " ",
                };

                break;
              case "notApplicable":
              default:
                ele["BOM Manager Result " + (index + 1)] = {
                  text: [{ class: "tdSubTitle", text: "Not Applicable" }],
                  class: "bg-light-maroon",
                };
                ele["Quote " + (index + 1)] = {
                  text: [
                    { class: "tdSubTitle", text: resolvedCurrency + "0.00" },
                  ],
                  class: "bg-yellow",
                };
                ele["Tariff Charge " + (index + 1)] = {
                  text: [{ class: "tdSubTitle", text: "N/A" }],
                  class: "bg-yellow",
                };

                break;
            }
          }
        } else {
          ele["BOM Manager Result " + (index + 1)] = {
            text: [{ class: "tdSubTitle", text: "Not Applicable" }],
            class: "bg-light-maroon",
          };
          ele["Quote " + (index + 1)] = {
            text: [{ class: "tdSubTitle", text: resolvedCurrency + "0.00" }],
            class: "bg-yellow",
          };
          ele["Tariff Charge " + (index + 1)] = {
            text: [{ class: "tdSubTitle", text: "N/A" }],
            class: "bg-yellow",
          };
        }
      });
      return ele;
    });

    const attritionByPackage = await this.loadAttritionMap();
    const withAttrition = applyAttritionQtyColumns(
      updateRecords,
      this.state.quoteData,
      attritionByPackage,
    );

    const synced = withAttrition.map((row, i) => {
      const lineIndex = this.resolveBomLineIndex(row, i);
      const prev = findPreviousLine(lineIndex);
      let next = {
        ...row,
        _bomLineIndex: lineIndex,
      };
      if (prev && isRealBomLine(row)) {
        Object.keys(prev).forEach((key) => {
          if (
            isAttrQtyColumn(key) &&
            prev[key] !== undefined &&
            prev[key] !== ""
          ) {
            next[key] = prev[key];
          }
        });
        next = preserveAlternateLineState(prev, next);
      }
      return syncQuoteQtyFromAttrition(next, postQuote.quotes);
    });

    if (resolvedCurrency && resolvedCurrency !== this.state.currancy) {
      this.setState({ currancy: resolvedCurrency });
    }

    return organizeBomByMountingType(synced);
  };

  addTotalColumn = async (postQuote, records) => {
    this.clearQuote();
    let quotesDetail = records?.quotesDetail || {};
    let updatedData = records?.partsDetail || [];
    let tariffTotalData = records?.tariffTotals || {};
    const templateLine =
      (Array.isArray(updatedData) &&
        updatedData.find((line) => isRealBomLine(line))) ||
      updatedData[0] ||
      {};
    let totalColumn = Object.assign({}, templateLine);
    Object.keys(templateLine).forEach((e) => {
      totalColumn[e] = "";
    });
    await postQuote.quotes.forEach((item, index) => {
      const quoteTotals =
        quotesDetail[item] || quotesDetail[String(item)] || {};
      let total = 0;
      let tariffTotal = 0;
      if (Array.isArray(updatedData)) {
        updatedData.forEach((line) => {
          if (!isRealBomLine(line)) {
            return;
          }
          total += parseDisplayedQuoteAmount(line["Quote " + (index + 1)]);
          tariffTotal += parseDisplayedQuoteAmount(
            line["Tariff Charge " + (index + 1)],
          );
        });
      }
      total = Math.round(total * 100) / 100;
      tariffTotal = Math.round(tariffTotal * 100) / 100;
      if (!total && Number(quoteTotals.total)) {
        // Fallback only when line cells were not populated yet.
        const hasQuoteCells = Array.isArray(updatedData)
          ? updatedData.some(
              (line) =>
                isRealBomLine(line) &&
                line["Quote " + (index + 1)] != null &&
                line["Quote " + (index + 1)] !== "",
            )
          : false;
        if (!hasQuoteCells) {
          total = Number(quoteTotals.total) || 0;
          tariffTotal =
            Number(tariffTotalData[item] ?? tariffTotalData[String(item)]) || 0;
        }
      }
      let percentage = Number(quoteTotals.percentage) || 0;
      let quoteData = this.state.quoteData;
      quoteData["quote" + (index + 1)] = item;
      this.setState({
        ...quoteData,
        ["quoteRef" + (index + 1)]: this.state.currancy + total,
        ["percentageRef" + (index + 1)]: percentage,
      });
      totalColumn["Quote " + (index + 1)] = formatQuoteAmount(
        total,
        this.state.currancy,
        `${this.state.currancy || "$"}0.00`,
      );
      totalColumn["Tariff Charge " + (index + 1)] = formatQuoteAmount(
        tariffTotal,
        this.state.currancy,
        `${this.state.currancy || "$"}0.00`,
      );
      return totalColumn;
    });
    return totalColumn;
  };

  autoQuote = async () => {
    if (this.isSyncMissingInfoRunning()) {
      return;
    }
    this.setState({ scrappingPercent: 0 });
    const selectedVendors = localStorage.getItem("selectedVendors");
    if (this.props.importRecordes.bomId) {
      this.setState({ isLoading: true });
      let postQuote = {
        bom_id: this.props.importRecordes.bomId,
        quotes: buildQuotesPayload(this.state.quoteData),
      };
      if (this.state.quoteVendors !== "All") {
        var selectedVendorsArray = selectedVendors.split(",");
        postQuote.filters = { distributors_list: selectedVendorsArray };
      }

      postQuote.quotes = postQuote.quotes.filter(Boolean);
      if (!postQuote.quotes.length) {
        this.setState({ isLoading: false });
        return toaster(ToastsStore, "error", "Please fill auto quote.");
      }

      const attritionByPackage = await this.loadAttritionMap();
      const bomlinesWithAttrition = applyAttritionQtyColumns(
        this.props.importRecordes.bomlines,
        this.state.quoteData,
        attritionByPackage,
        { preserveAttrEdits: true },
      );

      const obsoleteMissingAlternates = getObsoleteLinesMissingAlternate(
        bomlinesWithAttrition,
      ).filter(
        // Only block when the part actually has alternatives available to choose from.
        // Parts with 0 alternatives cannot be resolved by the user and must not block quoting.
        (line) =>
          Array.isArray(line.substitutes) && line.substitutes.length > 0,
      );
      if (obsoleteMissingAlternates.length > 0) {
        this.setState({ isLoading: false });
        const mpns = obsoleteMissingAlternates
          .map(
            (line) =>
              line.obsolete_part_number || line.manufacturer_part_number,
          )
          .filter(Boolean)
          .join(", ");
        return toaster(
          ToastsStore,
          "error",
          `Select alternates for obsolete part(s) before quoting: ${mpns}`,
        );
      }

      const unmatchedSkippedForQuote = getUnmatchedLinesSkippedForQuote(
        bomlinesWithAttrition,
      );

      this.props.updateQuotes({
        bomlines: bomlinesWithAttrition,
        quotes: this.props.importRecordes.quotes || [],
      });
      postQuote.line_quote_quantities = buildLineQuoteQuantities(
        bomlinesWithAttrition,
        postQuote.quotes,
      );
      postQuote.line_attrition_quantities = buildLineAttritionDetails(
        bomlinesWithAttrition,
        postQuote.quotes,
      );
      postQuote.line_alternate_mpns = buildLineAlternateMpns(
        bomlinesWithAttrition,
      );
      postQuote.line_alternate_manufacturers = buildLineAlternateManufacturers(
        bomlinesWithAttrition,
      );
      postQuote.line_alternate_selections = buildLineAlternateSelections(
        bomlinesWithAttrition,
      );
      postQuote.skip_unmatched_part_ids = unmatchedSkippedForQuote
        .map((line) => Number(line.part_id))
        .filter((id) => Number.isFinite(id) && id > 0);
      postQuote.skip_unmatched_mpns = unmatchedSkippedForQuote
        .map((line) =>
          String(
            line.unmatched_original_mpn || line.manufacturer_part_number || "",
          ).trim(),
        )
        .filter(Boolean);

      this.stopScrappingPercentPoll();
      this.setState({
        getScrappingPercent: false,
        scrappingPercent: 0,
        loadingMessage: "Getting quotes. Please wait.",
      });
      try {
        const GET_QUOTE_URL =
          localStorage.getItem("isDebug") === "1"
            ? GET_QUOTE + "?debug=1"
            : GET_QUOTE;
        const res = await fetch(GET_QUOTE_URL, {
          method: "POST",
          headers: {
            authorization: "Bearer " + this.props.user.token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postQuote),
        });

        const data = await res.json();

        this.stopScrappingPercentPoll();
        this.setState({ importSimPercent: 100 });
        if (data.code >= 200 && data.code < 400) {
          let updatedData = await this.addQuoteColummns(postQuote, data.data);
          let generateTotals = { ...data.data, partsDetail: updatedData };
          let totalQuote = await this.addTotalColumn(postQuote, generateTotals);
          updatedData.push(totalQuote);
          let quotes = buildQuotesSnapshot(this.state.quoteData, this.state);

          const syncedExcelData = (
            this.props.importRecordes.excelData || []
          ).map((row, i) => {
            const bomLine = updatedData.find(
              (line) =>
                isRealBomLine(line) &&
                line._bomLineIndex ===
                  (row._bomLineIndex != null ? row._bomLineIndex : i),
            );
            if (!bomLine) {
              return row;
            }
            return preserveAlternateLineState(row, {
              ...bomLine,
              _bomLineIndex: row._bomLineIndex != null ? row._bomLineIndex : i,
            });
          });

          const backendFreight = data.data?.freightDetails || {};
          const costPerVendor =
            backendFreight.cost_per_vendor != null
              ? Number(backendFreight.cost_per_vendor)
              : Number(this.props.systemSettings?.FREIGHT_COST_PER_VENDOR) || 0;
          const quotedVendorCount = this.getQuotedVendorCount(updatedData);
          const quotedVendorNames = this.getQuotedVendorNames(updatedData);
          const resolvedFreightDetails = {
            total: Math.round(quotedVendorCount * costPerVendor * 100) / 100,
            cost_per_vendor: Number.isFinite(costPerVendor) ? costPerVendor : 0,
            vendor_count: quotedVendorCount,
            vendors_name:
              Array.isArray(backendFreight.vendors_name) &&
              backendFreight.vendors_name.length
                ? backendFreight.vendors_name
                : quotedVendorNames,
          };

          const displayedTariffTotal = updatedData.reduce((sum, line) => {
            if (!isRealBomLine(line)) {
              return sum;
            }
            return (
              sum +
              postQuote.quotes.reduce(
                (quoteSum, _quoteQty, index) =>
                  quoteSum +
                  parseDisplayedQuoteAmount(
                    line["Tariff Charge " + (index + 1)],
                  ),
                0,
              )
            );
          }, 0);

          this.setState({
            tariffTotal: Math.round(displayedTariffTotal * 100) / 100,
            freightTotal: resolvedFreightDetails.total,
          });

          this.props.updateQuotes({
            bomlines: updatedData,
            excelData: syncedExcelData,
            quotes,
            issue_report: data.data.issue_report || null,
          });
          const skippedUnmatchedCount = unmatchedSkippedForQuote.length;
          toaster(
            ToastsStore,
            "success",
            skippedUnmatchedCount > 0
              ? `Auto quote completed. ${skippedUnmatchedCount} unmatched part${
                  skippedUnmatchedCount === 1 ? " was" : "s were"
                } skipped due to no suggested part availability.`
              : "Auto quote completed.",
          );
          this.setState({
            exportEnable: true,
            isLoading: false,
            getScrappingPercent: false,
            loadingMessage: "",
          });

          // Persist attrition-adjusted columns into result BOM for History
          try {
            await ExportExcel(
              this.props.user,
              {
                ...this.props.importRecordes,
                bomlines: updatedData,
                bomId: this.props.importRecordes.bomId,
                issue_report:
                  data.data.issue_report ||
                  this.props.importRecordes.issue_report,
              },
              this.props.importRecordes.invalidQuantityColumns,
              this.props.columns,
              false,
              this.state.bomChecklists,
              {
                ...this.getExportTotals(updatedData),
                freightTotal: resolvedFreightDetails.total,
                tariffTotal: Number(generateTotals.tariffTotals?.total) || 0,
                freightCostPerVendor: resolvedFreightDetails.cost_per_vendor,
                freightVendorCount: resolvedFreightDetails.vendor_count,
                vendorNames: resolvedFreightDetails.vendors_name,
                freightDetails: backendFreight,
              },
            );
          } catch (exportError) {
            console.log(exportError);
          }
        } else {
          if (data.message || data.debug_message) {
            alert(apiErrorMessage(data, "Internal Server Error"));
          }
        }
      } catch (e) {
        console.error(e);
        toaster(
          ToastsStore,
          "error",
          "Auto quote failed while applying quote columns.",
        );
      } finally {
        this.stopScrappingPercentPoll();
        this.setState({
          isLoading: false,
          getScrappingPercent: false,
          loadingMessage: "",
        });
      }
    } else {
      toaster(
        ToastsStore,
        "error",
        "Please import file to generate auto quote.",
      );
      this.setState({ isLoading: false });
    }
  };

  clearQuote = () => {
    this.setState({
      quoteData: {},
      ...buildInitialQuoteRefState(),
      showNeedAttentionRows: false,
    });
  };

  renderQuoteRow = (slot) => {
    const quoteKey = `quote${slot}`;
    const quoteRefKey = `quoteRef${slot}`;
    const percentageRefKey = `percentageRef${slot}`;
    const quoteRefValue = this.state[quoteRefKey];

    return (
      <tr key={slot}>
        <td>
          <span>{`Quote ${slot}`}</span>
        </td>
        <td>
          <Input
            type="text"
            tabIndex={slot}
            placeholder="0"
            name={quoteKey}
            value={this.state.quoteData[quoteKey] || ""}
            onChange={(e) => this.fillQuote(e)}
          />
        </td>
        <td>
          <Input
            type="text"
            value={quoteRefValue !== "$0.00" ? quoteRefValue : ""}
            placeholder="$0.00"
            readOnly
          />
        </td>
        <td>
          <Input
            type="text"
            value={this.state[percentageRefKey]}
            placeholder="%"
            readOnly
          />
        </td>
      </tr>
    );
  };

  rowNeedsAttention = (row) => {
    let rowNeedsAttention = false;
    Object.values(row).map((item) => {
      if (
        item != null &&
        typeof item === "object" &&
        item["class"] === "bg-light-maroon"
      ) {
        rowNeedsAttention = true;
      }
      return null;
    });
    return rowNeedsAttention;
  };

  render() {
    const { columns, columnAliases, importRecordes } = this.props;
    const initColumnLength = parseInt(localStorage.getItem("importColumn"));
    return (
      <Layouts>
        <OverlayLoader
          show={this.state.isLoading}
          scrappingPercent={
            this.state.getScrappingPercent
              ? this.state.scrappingPercent
              : this.state.enrichmentProgress?.percent ||
                this.state.importSimPercent
          }
          message={this.state.loadingMessage || "Processing data. Please wait."}
          enrichmentStats={this.state.enrichmentProgress}
        />
        <OverlayLoader
          show={
            !!this.state.refreshingDigiKeyLineKey &&
            !this.state.isLoading &&
            !this.state.syncMissingInfoRunning
          }
          message="Refreshing DigiKey details. Please wait."
          hint="Please wait — DigiKey enrichment can take a minute or two."
        />
        <div className="theme-form bg-dark-gray importBlock">
          <Row>
            <Col xl="3">
              <h4>Import BOM File </h4>
              <Row>
                <Col md="6" xl="12">
                  <Label
                    className={classNames(
                      "btn-block text-center importBtn selected",
                    )}
                  >
                    <ImportIcon className="mr-2" />
                    <input
                      className="d-none"
                      ref={this.inputRef}
                      type="file"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      onChange={(e) => this.fileUpload(e.target.files)}
                    />
                    Import BOM
                  </Label>
                </Col>
                <Col md="6" xl="12">
                  <ImportFromHistory
                    importFromHistoryModalOpen={() => {
                      this.toggleImportFromHistoryModal();
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col xl="9">
              <Row>
                <Col xl="6">
                  <h4>Auto Quotes</h4>
                  <table className="table quoteTable mb-xl-0">
                    <tbody>
                      {quoteSlotNumbers()
                        .slice(0, 5)
                        .map((slot) => this.renderQuoteRow(slot))}
                    </tbody>
                  </table>
                </Col>
                <Col xl="6">
                  <h4>Auto Quotes</h4>
                  <table className="table quoteTable mb-xl-0">
                    <tbody>
                      {quoteSlotNumbers()
                        .slice(5)
                        .map((slot) => this.renderQuoteRow(slot))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* <Row>
                        <Col>
                            <Label className="customCheckbox d-inline-block">
                                <Input type="checkbox" name="checkbox1" />
                                <span className="span-text">Octo Part Columns</span>
                            </Label>
                            <Label className="customCheckbox d-inline-block">
                                <Input type="checkbox" name="checkbox2" />
                                <span className="span-text">Get Digi-Key Descriptions</span>
                            </Label>
                            <Label className="customRadio d-inline-block">
                                <Input type="radio" name="radio" />
                                <span className="span-text">Part Number Exact Match</span>
                            </Label>
                            <Label className="customRadio d-inline-block">
                                <Input type="radio" name="radio" />
                                <span className="span-text">Add Wildcard*</span>
                            </Label>
                        </Col>
                    </Row> */}
        </div>
        <div className="theme-form importBlock">
          <Row className="align-items-center">
            <Col xl="3">
              <fieldset className="fieldset">
                <legend>Vendors</legend>
                <Label className="customRadio d-inline-block">
                  <Input
                    type="radio"
                    name="vendor"
                    value="All"
                    checked={this.state.quoteVendors === "All" ? true : false}
                    onChange={(e) => this.fillQuoteVendors(e)}
                  />
                  <span className="span-text">All</span>
                </Label>
                <Label className="customRadio d-inline-block pr-0">
                  <Input
                    type="radio"
                    name="vendor"
                    value="Approves"
                    checked={
                      this.state.quoteVendors === "Approves" ? true : false
                    }
                    onChange={(e) => this.fillQuoteVendors(e)}
                  />
                  <span className="span-text">Approved</span>
                </Label>
              </fieldset>
            </Col>
            <Col xl="7 validOption">
              {/* <fieldset className="fieldset">
                <legend>Valid Options</legend>
                <Row>
                  <Col md="6" className="xl-flex">
                    <TextLabel>Valid BOM Items</TextLabel>
                    <Input type="text" />
                  </Col>
                  <Col md="6" className="xl-flex">
                    <TextLabel>Valid Alternatives</TextLabel>
                    <Input type="text" />
                  </Col>
                </Row>
              </fieldset> */}
            </Col>
            <Col xl="2">
              <span
                className="d-block"
                onMouseEnter={
                  this.isSyncMissingInfoRunning()
                    ? this.notifySyncInProgress
                    : undefined
                }
              >
                <Button
                  className={classNames("btn-block autoQuoteBtn ", {
                    selected:
                      Object.values(this.state.quoteData).toString().length &&
                      this.props.importRecordes.bomId !== undefined &&
                      !this.isSyncMissingInfoRunning(),
                  })}
                  disabled={
                    !Object.values(this.state.quoteData).toString().length ||
                    this.props.importRecordes.bomId === undefined ||
                    !!this.state.refreshingDigiKeyLineKey ||
                    this.isSyncMissingInfoRunning()
                  }
                  onClick={this.autoQuote}
                >
                  Auto Quote
                </Button>
              </span>
            </Col>
          </Row>
        </div>
        <div className="importBlock bg-gradient">
          {this.state.importFinish ? (
            <div className="importBlock radius-8 bg-white">
              <div className="bomHeaderRow">
                <div className="bomMetaInfo">
                  <FileInfo>
                    <TextLabel>Customer Name</TextLabel>
                    <h5>{importRecordes.name}</h5>
                  </FileInfo>
                  <FileInfo>
                    <TextLabel>Date</TextLabel>
                    <h5>
                      <Moment format="DD MMM, YYYY">
                        {importRecordes.date
                          ? importRecordes.date
                          : this.state.today}
                      </Moment>
                    </h5>
                  </FileInfo>
                  <FileInfo>
                    <TextLabel>Part #REV</TextLabel>
                    <h5>{importRecordes.part}</h5>
                  </FileInfo>
                  <FileInfo>
                    <TextLabel>BOM Quote ID</TextLabel>
                    <h5>{importRecordes.bomId}</h5>
                  </FileInfo>
                </div>
                <div className="bomActionToolbar">
                  <DownloadButton
                    className="linkBtn download"
                    syncing={this.isSyncMissingInfoRunning()}
                    onSyncingHover={this.notifySyncInProgress}
                    onClick={async () => {
                      if (this.isSyncMissingInfoRunning()) {
                        return;
                      }
                      await ExportExcel(
                        this.props.user,
                        this.props.importRecordes,
                        this.props.importRecordes.invalidQuantityColumns,
                        columns,
                        true,
                        this.state.bomChecklists,
                        this.getExportTotals(),
                      );
                    }}
                  />
                  <EmailButton
                    className="linkBtn download"
                    syncing={this.isSyncMissingInfoRunning()}
                    onSyncingHover={this.notifySyncInProgress}
                    onClick={async () => {
                      if (this.isSyncMissingInfoRunning()) {
                        return;
                      }
                      await ExportExcel(
                        this.props.user,
                        this.props.importRecordes,
                        this.props.importRecordes.invalidQuantityColumns,
                        columns,
                        false,
                        this.state.bomChecklists,
                        this.getExportTotals(),
                      );

                      const bomDetails = await this.props.getBomDetails(
                        this.props.user.token,
                        this.props.importRecordes.bomId,
                      );
                      let data = await this.props.shareFile(
                        this.props.user.token,
                        bomDetails?.data?.result_file_path,
                        "Result-" + bomDetails?.data?.file_name + ".xlsx",
                      );
                      if (data.status >= 200 && data.status < 400) {
                        toaster(
                          ToastsStore,
                          "success",
                          "Sent the BOM file to your registered email.",
                        );
                      } else {
                        data = await this.props.shareFile(
                          this.props.user.token,
                          bomDetails?.data?.file_path,
                          bomDetails?.data?.file_name + ".xlsx",
                        );
                        if (data.status >= 200 && data.status < 400) {
                          toaster(
                            ToastsStore,
                            "success",
                            "Sent the BOM file to your registered email.",
                          );
                        } else if (data.status === 404) {
                          toaster(
                            ToastsStore,
                            "error",
                            "Could not find the file.",
                          );
                        } else {
                          toaster(
                            ToastsStore,
                            "error",
                            "Could not get the file.",
                          );
                        }
                      }
                    }}
                  />
                  <NeedAttentionButton
                    className="linkBtn needAttention"
                    onClick={() => {
                      this.setState((prevState) => {
                        return {
                          ...prevState,
                          showNeedAttentionRows:
                            !prevState.showNeedAttentionRows,
                        };
                      });
                    }}
                  />
                  <SyncMissingInfoButton
                    badgeCount={this.getSyncMissingInfoBadgeCount()}
                    onClick={this.openSyncMissingInfoModal}
                  />
                  <BomIssuesButton
                    badgeCount={getIssueCountBadge(
                      this.props.importRecordes.issue_report,
                    )}
                    onClick={this.openBomIssueReport}
                  />
                </div>
              </div>
              <div className="table-responsive mh-430">
                <Table className="table-bordered table-gray hovered mb-0 table-sticky-header">
                  <thead>
                    <tr>
                      {importRecordes &&
                        getTableColumnKeys(importRecordes.bomlines).map(
                          (item, index) => {
                            let colName = importRecordes.selectedColumns.find(
                              (column) => column.value === item,
                            );
                            return (
                              <th
                                key={index}
                                className={classNames({
                                  "bg-green":
                                    initColumnLength <= index &&
                                    !isAttritionQtyColumn(item) &&
                                    item.indexOf("Quote ") === -1,
                                  "bg-blue": item.indexOf("Quote ") !== -1,
                                  "bg-warning": isAttritionQtyColumn(item),
                                })}
                              >
                                {colName !== undefined ? colName.name : item}
                              </th>
                            );
                          },
                        )}
                    </tr>
                  </thead>
                  <tbody className="">
                    {importRecordes &&
                      importRecordes.bomlines.map((item, key) => {
                        if (isBomSectionRow(item)) {
                          const columnCount = getTableColumnKeys(
                            importRecordes.bomlines,
                          ).length;
                          return (
                            <tr key={key} className="bom-section-row">
                              <td
                                colSpan={columnCount}
                                className="bg-secondary text-white font-weight-bold"
                              >
                                <span className="bom-section-title">
                                  {item._section_title ||
                                    item.manufacturer_part_number ||
                                    ""}
                                </span>
                              </td>
                            </tr>
                          );
                        }
                        if (
                          this.state.showNeedAttentionRows === false ||
                          this.rowNeedsAttention(item)
                        ) {
                          return (
                            <tr
                              key={key}
                              className={classNames({
                                [LEADLESS_ROW_CLASS]: isLeadlessLine(item),
                                [OBSOLETE_ROW_CLASS]:
                                  isObsoleteLine(item) &&
                                  !hasLineAlternateSelected(item),
                                [UNMATCHED_RESOLVED_ROW_CLASS]:
                                  isUnmatchedLine(item) &&
                                  hasLineAlternateSelected(item),
                                [UNMATCHED_ROW_CLASS]:
                                  isUnmatchedLine(item) &&
                                  !hasLineAlternateSelected(item),
                                "obsolete-row-selectable": isObsoleteLine(item),
                              })}
                              onClick={
                                isObsoleteLine(item)
                                  ? (event) =>
                                      this.handleObsoleteRowClick(item, event)
                                  : undefined
                              }
                              title={
                                isObsoleteLine(item)
                                  ? getObsoleteRowTooltip(item)
                                  : isUnmatchedLine(item)
                                    ? item.unmatched_warning || undefined
                                    : undefined
                              }
                            >
                              {getTableColumnKeys(importRecordes.bomlines).map(
                                (col, index) => {
                                  if (col === "designator_color") {
                                    return null;
                                  }
                                  if (
                                    item[col] != null &&
                                    typeof item[col] === "object" &&
                                    item[col].description != null &&
                                    col !== "designator_color"
                                  ) {
                                    return (
                                      <td key={index}>
                                        {item[col].description.map(
                                          (d, dIdx) => {
                                            return (
                                              <React.Fragment key={dIdx}>
                                                {d.link && !d.key ? (
                                                  <a
                                                    href={d.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    {d.linkText || "Datasheet"}
                                                  </a>
                                                ) : (
                                                  <span className="tdpartsDetailsEntry">
                                                    <span className="tdpartsDetailsKey">
                                                      {d.key + ": "}
                                                    </span>
                                                    <span className="tdpartsDetailsValue">
                                                      {d.link ? (
                                                        <a
                                                          href={d.link}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          {d.linkText}
                                                        </a>
                                                      ) : d.value ? (
                                                        d.value
                                                      ) : (
                                                        "n/a"
                                                      )}
                                                    </span>
                                                  </span>
                                                )}
                                                <br />
                                              </React.Fragment>
                                            );
                                          },
                                        )}
                                      </td>
                                    );
                                  }

                                  if (
                                    item[col] != null &&
                                    typeof item[col] === "object" &&
                                    item[col].part_status != null &&
                                    col !== "designator_color"
                                  ) {
                                    return (
                                      <td key={index}>
                                        {item[col].part_status.map(
                                          (d, statusIndex) => {
                                            return (
                                              <React.Fragment key={statusIndex}>
                                                <span className="tdpartsDetailsEntry">
                                                  <span className="tdpartsDetailsKey">
                                                    {d.key + ": "}
                                                  </span>
                                                  <span className="tdpartsDetailsValue">
                                                    {d.value ? d.value : "n/a"}
                                                  </span>
                                                </span>
                                                <br />
                                              </React.Fragment>
                                            );
                                          },
                                        )}
                                      </td>
                                    );
                                  }

                                  if (
                                    item[col] != null &&
                                    typeof item[col] === "object" &&
                                    col !== "designator_color"
                                  ) {
                                    return (
                                      <td
                                        key={index}
                                        className={classNames(item[col].class)}
                                      >
                                        <span className="tdTitle">
                                          {item[col].title}
                                        </span>
                                        <br />
                                        {item[col].text.map((t, tIdx) => {
                                          const text =
                                            typeof t.text === "string" &&
                                            /undefined/i.test(t.text)
                                              ? "N/A"
                                              : t.text;
                                          return (
                                            <span
                                              key={tIdx}
                                              className={t.class}
                                            >
                                              {text}
                                            </span>
                                          );
                                        })}
                                      </td>
                                    );
                                  }

                                  if (
                                    item[col] != null &&
                                    col === "designator" &&
                                    col !== "designator_color"
                                  ) {
                                    return (
                                      <td
                                        key={index}
                                        className={
                                          importRecordes.invalidQuantityColumns.includes(
                                            key + 1,
                                          ) && col === "quantity"
                                            ? classNames("bg-light-maroon")
                                            : ""
                                        }
                                      >
                                        {item["designator_color"] ? (
                                          <p style={{ color: "#a02b93" }}>
                                            <b>{item[col]}</b>
                                          </p>
                                        ) : (
                                          <p>{item[col]}</p>
                                        )}
                                      </td>
                                    );
                                  }

                                  if (col !== "designator_color") {
                                    return (
                                      <td
                                        key={index}
                                        className={
                                          importRecordes.invalidQuantityColumns.includes(
                                            (item._bomLineIndex != null
                                              ? item._bomLineIndex
                                              : key) + 1,
                                          ) && col === "quantity"
                                            ? classNames("bg-light-maroon")
                                            : ""
                                        }
                                      >
                                        {isAttrQtyColumn(col) &&
                                        isRealBomLine(item) ? (
                                          <Input
                                            type="number"
                                            min="0"
                                            className="form-control form-control-sm"
                                            value={
                                              item[col] === 0 || item[col]
                                                ? item[col]
                                                : ""
                                            }
                                            onClick={(e) => e.stopPropagation()}
                                            onFocus={(e) => e.stopPropagation()}
                                            onChange={(e) =>
                                              this.handleAttrQtyChange(
                                                key,
                                                col,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : col ===
                                            "manufacturer_part_number" &&
                                          isUnmatchedLine(item) ? (
                                          <div className="unmatched-mpn-cell">
                                            {hasLineAlternateSelected(item) ? (
                                              <>
                                                <SelectedAlternateMpnRow
                                                  mpn={item.selected_alternate_mpn}
                                                  mpnClassName="unmatched-selected-mpn"
                                                  label={
                                                    resolveLineSelectedAlternateRecommendation(
                                                      item,
                                                    ).label
                                                  }
                                                  text={
                                                    resolveLineSelectedAlternateRecommendation(
                                                      item,
                                                    ).text
                                                  }
                                                />
                                                <small className="text-muted unmatched-replaces-label obsolete-mpn-meta">
                                                  Unmatched:{" "}
                                                  {item.unmatched_original_mpn ||
                                                    item.manufacturer_part_number}
                                                </small>
                                                <div className="obsolete-mpn-action">
                                                  {this.renderUnmatchedViewOptionsAction(
                                                    item,
                                                    "Change suggested part",
                                                  )}
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                <span>
                                                  {item.unmatched_original_mpn ||
                                                    item.manufacturer_part_number}
                                                </span>
                                                <br />
                                                <span className="text-muted small">
                                                  {
                                                    UNMATCHED_EXACT_MATCH_MESSAGE
                                                  }{" "}
                                                  {this.renderUnmatchedViewOptionsAction(
                                                    item,
                                                  )}
                                                </span>
                                              </>
                                            )}
                                          </div>
                                        ) : col ===
                                            "manufacturer_part_number" &&
                                          isObsoleteLine(item) ? (
                                          <div className="obsolete-mpn-cell">
                                            {hasObsoleteAlternateSelected(
                                              item,
                                            ) ? (
                                              <>
                                                <SelectedAlternateMpnRow
                                                  mpn={item.selected_alternate_mpn}
                                                  label={
                                                    resolveLineSelectedAlternateRecommendation(
                                                      item,
                                                    ).label
                                                  }
                                                  text={
                                                    resolveLineSelectedAlternateRecommendation(
                                                      item,
                                                    ).text
                                                  }
                                                />
                                                <small className="text-muted obsolete-replaces-label obsolete-mpn-meta">
                                                  Obsolete:{" "}
                                                  {item.obsolete_part_number ||
                                                    item.manufacturer_part_number}
                                                </small>
                                              </>
                                            ) : (
                                              <span>
                                                {item.obsolete_part_number ||
                                                  item.manufacturer_part_number}
                                              </span>
                                            )}
                                            <div className="obsolete-mpn-action">
                                              <button
                                                type="button"
                                                className="obsolete-select-link"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  this.openObsoletePartsReviewModal(
                                                    item,
                                                  );
                                                }}
                                              >
                                              {getObsoleteAlternateCount(item) >
                                              0
                                                ? `Alternates: ${getObsoleteAlternateCount(item)} – click to select`
                                                : "Click to select"}
                                            </button>
                                            </div>
                                          </div>
                                        ) : col ===
                                            "manufacturer_part_number" &&
                                          item["designator_color"] ? (
                                          <p style={{ color: "#a02b93" }}>
                                            <b>{item[col]}</b>
                                          </p>
                                        ) : isExportManufacturerColumn(col) &&
                                          hasLineAlternateSelected(item) ? (
                                          getExportManufacturer(item) ||
                                          item[col]
                                        ) : (
                                          <>
                                            {item[col]}
                                            {col ===
                                              DIGIKEY_REFRESH_DETAILS_COLUMN &&
                                            lineNeedsDigiKeyDetailsRefresh(
                                              item,
                                            ) ? (
                                              <button
                                                type="button"
                                                className={classNames(
                                                  "digikey-refresh-btn",
                                                  {
                                                    "is-spinning":
                                                      this.state
                                                        .refreshingDigiKeyLineKey ===
                                                      getDigiKeyRefreshLineKey(
                                                        item,
                                                      ),
                                                  },
                                                )}
                                                title={
                                                  DIGIKEY_REFRESH_DETAILS_LABEL
                                                }
                                                aria-label={
                                                  DIGIKEY_REFRESH_DETAILS_LABEL
                                                }
                                                disabled={
                                                  !!this.state
                                                    .refreshingDigiKeyLineKey ||
                                                  this.state
                                                    .syncMissingInfoRunning
                                                }
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  this.refreshDigiKeyDetailsForLine(
                                                    item,
                                                  );
                                                }}
                                              >
                                                <i
                                                  className={classNames(
                                                    "fa fa-refresh",
                                                    {
                                                      "fa-spin":
                                                        this.state
                                                          .refreshingDigiKeyLineKey ===
                                                        getDigiKeyRefreshLineKey(
                                                          item,
                                                        ),
                                                    },
                                                  )}
                                                  aria-hidden="true"
                                                />
                                              </button>
                                            ) : null}
                                          </>
                                        )}
                                      </td>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                },
                              )}
                            </tr>
                          );
                        }
                        return null;
                      })}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <div className="dropBlock">
              <Row className="justify-content-center">
                <Col md="9" lg="8">
                  <Dropzone
                    onDrop={(e) => this.fileUpload(e)}
                    onDragOver={() => this.setState({ highlightedBox: true })}
                    onDragLeave={() => this.setState({ highlightedBox: false })}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <DropBox
                        className={classNames({
                          highlightedBox: this.state.highlightedBox,
                        })}
                        {...getRootProps()}
                      >
                        <input
                          {...getInputProps()}
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                        <img src="/images/Shape.png" alt="file_icon" />
                        <img
                          className="active"
                          src="/images/Shape-fill.png"
                          alt="file_icon"
                        />
                        <h5>Drag and drop BOM file</h5>
                        <span>(.excel only)</span>
                      </DropBox>
                    )}
                  </Dropzone>
                </Col>
              </Row>
            </div>
          )}
        </div>
        {/* Preview Modal */}
        <ImportPreviewModal
          className="theme-form preview-modal"
          modal={this.state.previewData}
          toggleModal={this.toggleModal}
          toggleHistoryModal={this.closeImportFromHistoryModal}
          showBomLines={this.showBomLines}
          onMissingAttritions={this.onMissingAttritions}
          onObsoletePartsReview={this.onImportPartsReview}
          columns={columns}
          columnAliases={columnAliases}
          setLoading={(e) => this.setState({ isLoading: e })}
          setLoadingMessage={(msg) => this.setState({ loadingMessage: msg })}
          setLoadingPercent={(p) =>
            this.setState({ importSimPercent: Number(p) || 0 })
          }
          setEnrichmentProgress={(stats) =>
            this.setState({ enrichmentProgress: stats || null })
          }
          loginUser={this.props.user.token}
          saveCustomer={this.props.saveCustomer}
          savePartsRevs={this.props.savePartsRevs}
          data={this.state.data}
          file={this.state.file}
          sheets={this.state.sheets}
          fileUpload={this.fileUpload}
        />
        <MissingAttritionModal
          show={this.state.showMissingAttritionModal}
          rows={this.state.missingAttritionRows}
          token={this.props.user.token}
          insertAttritionList={this.props.insertAttritionList}
          onSaved={this.onMissingAttritionsSaved}
        />
        <ObsoletePartsReviewModal
          show={this.state.showObsoletePartsModal}
          bomlines={importRecordes.bomlines || []}
          focusLineKey={this.state.obsoletePartsFocusKey}
          token={this.props.user.token}
          onSave={this.onObsoletePartsSaved}
          onClose={this.closeObsoletePartsReviewModal}
          setLoading={(e) => this.setState({ isLoading: !!e })}
          setLoadingMessage={(msg) =>
            this.setState({ loadingMessage: msg || "" })
          }
          setLoadingPercent={(p) =>
            this.setState({ importSimPercent: Number(p) || 0 })
          }
        />
        <UnmatchedPartsReviewModal
          show={this.state.showUnmatchedPartsModal}
          reviewLine={this.state.unmatchedModalLine}
          token={this.props.user.token}
          onSave={this.onUnmatchedPartsSaved}
          onClose={this.closeUnmatchedPartsReviewModal}
        />
        <BomIssueReportModal
          isOpen={this.state.showIssueReportModal}
          toggle={() => this.setState({ showIssueReportModal: false })}
          issueReport={this.props.importRecordes.issue_report}
          bomName={importRecordes?.name}
          bomlines={importRecordes.bomlines || []}
          onIssueClick={this.handleIssueReportClick}
        />
        <SyncMissingInfoModal
          isOpen={this.state.showSyncMissingInfoModal}
          toggle={this.closeSyncMissingInfoModal}
          items={this.state.syncMissingInfoItems}
          isSyncing={this.state.syncMissingInfoRunning}
          onSync={() => this.startSyncMissingInfo({ retryFailed: true })}
        />
        <ImportFromHistoryModal
          className="theme-form preview-modal"
          modal={this.state.importFromHistoryModalOpen}
          toggle={this.toggleImportFromHistoryModal}
          user={this.props.user}
          fileUpload={this.fileUpload}
        />
      </Layouts>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  columns: state.column,
  columnAliases: state.columnAliases,
  importRecordes: state.importTable,
  systemSettings: state.systemSettings,
});

export default connect(mapStateToProps, {
  getColumns,
  getColumnAliases,
  getSystemSettings,
  saveCustomer,
  updateQuotes,
  savePartsRevs,
  getBomDetails,
  shareFile,
  insertAttritionList,
  getAttritions,
  checkAttritionPackages,
})(Home);
